import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  ClockCircleOutlined,
  DeleteOutlined,
  FilterOutlined,
  LineChartOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import ReactECharts from "echarts-for-react";
import {
  Button,
  Col,
  Row,
  Select,
  DatePicker,
  message,
  Spin,
  Dropdown,
  Tag,
  Tooltip,
  Modal,
  Table,
  Input,
  Card,
  Skeleton,
} from "antd";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import {
  getrawdataSource,
  getLeadStatus,
  deleteFilter,
  addFilter,
  getFilter,
  getallDeveloperForTask,
  getAllSources,
  getAllTags,
  updateFilter,
  getAllRawDataForPin,
} from "../../utils/API";
import dayjs, { Dayjs } from "dayjs";
import * as Icons from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import countries from "../../utils/country.json";
import { AuthContext } from "../../Auth/AuthContext";
import { getErrorMessage } from "../../utils/getErrorMessage";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { RiFileCopyLine, RiCheckLine } from "react-icons/ri";

const priorityColors: Record<string, string> = {
  High: "#e6533c",
  Medium: "#23b7e5",
  Low: "#26bf94",
};

const FilterTab = ({
  f,
  index,
  totalTabs,
  isActive,
  defaultFilterId,
  applyFavouriteFilter,
  setAsDefaultFilter,
  editFavouriteFilter,
}: any) => {
  const [isHovered, setIsHovered] = useState(false);

  const maxWords = 2;
  const words = f.name.split(" ");
  const isLong = words.length > maxWords;
  const displayText = isLong
    ? words.slice(0, maxWords).join(" ") + "..."
    : f.name;

  const content = (
    <div
      onClick={() => applyFavouriteFilter(f)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`snap-start flex-shrink-0 text-center cursor-pointer text-sm font-medium px-5 whitespace-nowrap overflow-hidden text-ellipsis relative pr-14 transition-colors flex items-center justify-center ${
        isActive
          ? "bg-[#001529] text-white"
          : "bg-white text-gray-700 hover:bg-gray-50"
      }`}
      style={{
        minWidth: "110px",
        height: "40px",
        borderRight: index !== totalTabs - 1 ? "1px solid #e5e7eb" : "none",
      }}
    >
      <span>{displayText}</span>
      <div
        className={`absolute right-7 top-1/2 -translate-y-1/2 transition-opacity duration-200 ${isHovered ? "opacity-100" : "opacity-0"}`}
        onClick={(e) => {
          e.stopPropagation();
          const r = e.currentTarget.getBoundingClientRect();
          const parent = e.currentTarget.closest(".la-page-wrap")?.getBoundingClientRect();
          editFavouriteFilter(f, parent ? r.left - parent.left : r.left);
        }}
        title="Edit filter"
      >
        <Icons.EditOutlined
          className={`${isActive ? "text-gray-200" : "text-gray-400"} hover:text-indigo-500 text-sm`}
        />
      </div>
      <div
        className={`absolute right-1 top-1/2 -translate-y-1/2 transition-opacity duration-200 ${defaultFilterId === f._id || isHovered ? "opacity-100" : "opacity-0"}`}
        onClick={(e) => setAsDefaultFilter(e, f)}
        title="Set as Default"
      >
        {defaultFilterId === f._id ? (
          <Icons.PushpinFilled className="text-yellow-500 text-sm" />
        ) : (
          <Icons.PushpinOutlined
            className={`${isActive ? "text-gray-300" : "text-gray-400"} hover:text-blue-400 text-sm`}
          />
        )}
      </div>
    </div>
  );

  return isLong ? <Tooltip title={f.name}>{content}</Tooltip> : content;
};

const LeadsAnalytics = () => {
  const { authData } = useContext(AuthContext);
  const userId = authData.user?._id;
  const isAdmin = authData.roleId?.roleId === 1;
  const isDeveloper = authData.roleId?.roleId === 2;
  const [source, setSource] = useState<
    Array<{
      sourceName: string;
      leadCount: number;
      category: string[];
      leadDates: string[];
    }>
  >([]);
  const [leadsByCategoryChartOptions, setLeadsByCategoryChartOptions] =
    useState<any>(null);
  const [leadsBarChartOptions, setLeadsBarChartOptions] = useState<any>(null);
  const [leadsLineChartOptions, setLeadsLineChartOptions] = useState<any>(null);
  const [metrics, setMetrics] = useState<any[]>([]);
  const [favouriteFilters, setFavouriteFilters] = useState<any[]>([]);
  const [selectedFav, setSelectedFav] = useState<number | null>(null);
  const [defaultFilterId, setDefaultFilterId] = useState<string | null>(
    localStorage.getItem("defaultLeadAnalyticsFilterId"),
  );
  const [filterDropdownOpen, setFilterDropdownOpen] = useState<boolean>(false);
  const [statusFilter, setStatusFilter] = useState<string[]>([]);
  const [page, setPage] = useState<number>(1);
  const [newFavName, setNewFavName] = useState("");
  const [editingFilterId, setEditingFilterId] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [statuses, setStatuses] = useState<
    Array<{
      _id: string;
      name: string;
      color: string;
      slug: string;
      createdAt: string;
      __v: number;
    }>
  >([]);
  const [leadAnalyticsModal, setLeadAnalyticsModal] = useState(false);
  const [inlineEditOpen, setInlineEditOpen] = useState(false);
  const [inlineCollapsed, setInlineCollapsed] = useState(false);
  const [inlineAnchorLeft, setInlineAnchorLeft] = useState<number>(0);
  const navigate = useNavigate();
  const [favName, setFavName] = useState("");
  const [selectedIcon, setSelectedIcon] = useState("");
  const [platform, setPlatform] = useState([]);
  const [developers, setDevelopers] = useState([]);
  const [sources, setSources] = useState<Array<string>>([]);
  const [tags, setTags] = useState<any>([]);
  const [totalLeads, setTotalLeads] = useState(0);
  const [totalLeadValue, setTotalLeadValue] = useState(0);
  const [totalLeadsChange, setTotalLeadsChange] = useState(0);
  const getCurrentTertial = () => {
    const month = dayjs().month(); // 0-11
    if (month >= 0 && month <= 3) return "jan-apr";
    if (month >= 4 && month <= 7) return "may-aug";
    return "sep-dec";
  };
  const [pipelineTimeframe, setPipelineTimeframe] = useState(getCurrentTertial());
  const [topDeals, setTopDeals] = useState<any[]>([]);
  const [allLeads, setAllLeads] = useState<any[]>([]);
  const [leadsByStatus, setLeadsByStatus] = useState<
    Array<{
      name: string;
      leadCount: number;
      leadValue: number;
      color: string;
    }>
  >([]);
  // --- state ---
  const [selectedSource, setSelectedSource] = useState<string[] | null>(null);
  const [selectedPlatform, setSelectedPlatform] = useState<string | null>(null);
  const [selectedPriority, setSelectedPriority] = useState<string | null>(null);
  const [selectedCountry, setSelectedCountry] = useState<string | null>(null);
  const [selectedStatus, setSelectedStatus] = useState<string[] | null>(null);
  const [selectedOwner, setSelectedOwner] = useState<string[] | null>(null);
  const [selectedTags, setSelectedTags] = useState<string[] | null>(null);
  const currentPathWithQuery = useMemo(
    () => location.pathname + location.search,
    [location.pathname, location.search],
  );

  //state for the DropDown

  const [timeFilter, setTimeFilter] = useState<
    | "today"
    | "yesterday"
    | "last7days"
    | "thisMonth"
    | "lastMonth"
    | "Last3Month"
    | "Last6Month"
    | "custom"
    | undefined
  >(undefined);
  const [followuptimeFilter, setfollowupTimeFilter] = useState<
    | "followupToday"
    | "followupYesterday"
    | "followupLast7Days"
    | "followupThisMonth"
    | "followupLastMonth"
    | "followupLast3Month"
    | "followupLast6Month"
    | "followupCustom"
    | undefined
  >(undefined);
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const [followupstartDate, setfollowupStartDate] = useState<Dayjs | null>(
    null,
  );
  const [followupendDate, setfollowupEndDate] = useState<Dayjs | null>(null);
  const [tempStartDate, setTempStartDate] = useState<Dayjs | null>(null);
  const [tempEndDate, setTempEndDate] = useState<Dayjs | null>(null);
  const [followuptempStartDate, setfollowupTempStartDate] =
    useState<Dayjs | null>(null);
  const [followuptempEndDate, setfollowupTempEndDate] = useState<Dayjs | null>(
    null,
  );
  const [showRangePicker, setShowRangePicker] = useState(false);
  const [followupshowRangePicker, setfollowupShowRangePicker] = useState(false);
  const [error, setError] = useState("");
  const [copiedId, setCopiedId] = useState<string | null>(null);

  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      const scrollEl = scrollRef.current;
      if (!scrollEl) return;

      setCanScrollLeft(scrollEl.scrollLeft > 0);
      setCanScrollRight(
        scrollEl.scrollWidth > scrollEl.clientWidth + scrollEl.scrollLeft,
      );
    };

    // Check initially
    checkScroll();

    // Optional: check on window resize
    window.addEventListener("resize", checkScroll);

    return () => window.removeEventListener("resize", checkScroll);
  }, [favouriteFilters]);

  useEffect(() => {
    const scrollEl = scrollRef.current;
    if (!scrollEl) return;

    const onScroll = () => {
      setCanScrollLeft(scrollEl.scrollLeft > 0);
      setCanScrollRight(
        scrollEl.scrollWidth > scrollEl.clientWidth + scrollEl.scrollLeft,
      );
    };

    scrollEl.addEventListener("scroll", onScroll);

    return () => scrollEl.removeEventListener("scroll", onScroll);
  }, []);

  const saveFilterOrder = async (newOrder: any[]) => {
    try {
      const updatedFilters = newOrder.map((filter, index) => ({
        ...filter,
        orderId: index + 1,
      }));

      const validFilters: any[] = [];

      // 🔁 Try updating one by one — keep only valid ones
      for (const f of updatedFilters) {
        try {
          await updateFilter(f._id, { orderId: f.orderId, type: "Analytics" });
          validFilters.push(f);
        } catch (err: any) {
          // 🔍 If filter not found, skip and delete locally
          console.warn(`Filter not found (deleted): ${f._id}`);
        }
      }

      // ✅ Replace localStorage and state with only valid filters
      localStorage.removeItem("favouriteFilters");
      saveFavouriteFilters(validFilters);
      setFavouriteFilters(validFilters);

      // ✅ If selectedFav no longer exists, reset it
      if (selectedFav && !validFilters.find((f) => f._id === selectedFav)) {
        setSelectedFav(null);
        localStorage.removeItem("selectedFavId");
      }

      message.success("Filter order updated!");
    } catch (error) {
      console.error("Failed to save filter order:", error);
      message.error("Failed to update filter order!");
    }
  };

  const onDragEnd = (result: any) => {
    if (!result.destination) return;

    const reordered = Array.from(favouriteFilters);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);

    saveFilterOrder(reordered); // 👈 updates backend + localStorage
  };

  const fetchStatuses = async () => {
    try {
      // 🛑 condition: skip if developer
      if (isDeveloper) {
        return [];
      }

      const response = await getLeadStatus();
      setStatuses(response.data);
      return response.data || [];
    } catch (error) {
      console.error("Error fetching statuses:", error);
      message.error("Failed to fetch statuses.");
      return [];
    }
  };

  const fetchDevelopers = async (userId: any, isAdmin: boolean) => {
    try {
      const res = await getallDeveloperForTask("", "");
      if (res.data) {
        if (isAdmin) {
          // Admin → show all owners
          const owners = res.data.filter((dev: any) => dev.isOwner === true);
          setDevelopers(owners);
        } else {
          // Normal user → show only their own name
          const self = res.data.filter((dev: any) => dev._id === userId._id);
          setDevelopers(self);
        }

        const platform = res.data.filter((dev: any) => dev.isPlatform === true);
        setPlatform(platform);
      }
    } catch (err) {
      console.error("Error fetching developers:", err);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchDevelopers(userId, isAdmin);
    }
  }, [userId, isAdmin]);

  const fetchSource = async () => {
    try {
      let allFetchedSources: any[] = [];
      let currentPage = 1;
      let totalPages = 1;
      
      do {
        const getSource = await getAllSources("", currentPage);
        if (getSource && getSource.sources) {
          allFetchedSources = [...allFetchedSources, ...getSource.sources];
          totalPages = getSource.totalPages || 1;
          currentPage++;
        } else {
          break;
        }
      } while (currentPage <= totalPages);

      let flatList: any[] = [];
      const flatten = (srcs: any[]) => {
        for (const src of srcs) {
          flatList.push(src);
          if (Array.isArray(src.sources)) {
            flatten(src.sources);
          }
        }
      };
      flatten(allFetchedSources);

      let filteredSource = flatList.filter((item: any) =>
        Array.isArray(item.category) ? item.category.includes("Sales") : item.category === "Sales"
      );
      setSources(filteredSource);
      return filteredSource;
    } catch (error) {
      console.error("Error fetching source:", error);
      return [];
    }
  };

  const fetchTags = async () => {
    if (isDeveloper) {
      return;
    }
    try {
      const getTags = await getAllTags();
      if (getTags) {
        let filteredTags = getTags.tags.filter((item: any) =>
          item.category.includes("Sales"),
        );
        setTags(filteredTags);
      }
    } catch (error) {
      console.error("Error fetching source:", error);
    }
  };

  useEffect(() => {
    fetchSource();
    fetchStatuses();
    fetchTags();
  }, [authData]);

  const statusOptions = statuses.map((status) => ({
    value: status.slug,
    label: (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <div
          style={{
            width: "12px",
            height: "12px",
            backgroundColor: status.color,
            borderRadius: "2px",
          }}
        />
        <span>{status.name}</span>
      </div>
    ),
  }));

  const handleStatusFilterChange = (value: string) => {
    let newFilter: string[] = [];

    if (statusFilter.includes(value)) {
      // Remove if already selected
      newFilter = statusFilter.filter((s) => s !== value);
    } else {
      // Add if not selected
      newFilter = [...statusFilter, value];
    }

    setStatusFilter(newFilter);
    setPage(1);
    // Trigger fetch immediately
    fetchLeadsSource({
      timeFilter,
      startDate: startDate ? startDate.format("YYYY-MM-DD") : null,
      endDate: endDate ? endDate.format("YYYY-MM-DD") : null,
      status: newFilter.length ? newFilter : [],
      page: 1,
    });
  };

  const fetchLeadsSource = async (
    params: any = {},
    loadedStatuses?: any[],
    loadedSources?: any[],
  ) => {
    setLoading(true);
    try {
      const activeStatuses =
        loadedStatuses && loadedStatuses.length > 0
          ? loadedStatuses
          : statuses;
      const currentSources =
        loadedSources && loadedSources.length > 0
          ? loadedSources
          : sources;
      let activeSources = currentSources;
      if (!activeSources || activeSources.length === 0) {
        activeSources = await fetchSource();
      }
      const currentTimeFilter = params.timeFilter ?? timeFilter;
      const currentStartDate =
        params.startDate ?? startDate?.format("YYYY-MM-DD");
      const currentEndDate = params.endDate ?? endDate?.format("YYYY-MM-DD");
      const currentStatus = params.status ?? statusFilter;

      const apiparams = {
        source: params.source || [],
        sourceid: params.sourceid || [],
        priority: params.priority || [],
        country: params.country || [],
        status: params.status || [],
        owner: params.owner || [],
        tags: params.tags || [],
        timeFilter: params.timeFilter || null,
        startDate: params.startDate || null,
        endDate: params.endDate || null,
        followupdate: params.followupdate || null,
        followupstartDate: params.followupstartDate || null,
        followupendDate: params.followupendDate || null,
        page: 1,
        limit: 9999,
      };

      // Fetch leads matching current filters for analytics aggregation
      let rawLeads: any[] = [];
      try {
        const rawRes = await getAllRawDataForPin(apiparams);
        if (rawRes && rawRes.data) {
          rawLeads = rawRes.data;
          setAllLeads(rawLeads);
          const statusMap: any = {};
          activeStatuses.forEach((s: any) => {
            statusMap[s.name] = {
              name: s.name,
              leadCount: 0,
              leadValue: 0,
              color: s.color || "#94a3b8",
            };
          });

          rawRes.data.forEach((lead: any) => {
            const leadStatus = lead.leadstatus || lead.status;
            let statusName = "Unknown";
            let statusColor = "#94a3b8";

            if (leadStatus) {
              if (typeof leadStatus === "string") {
                const found = activeStatuses.find(
                  (s: any) => s._id === leadStatus || s.slug === leadStatus || s.name === leadStatus
                );
                if (found) {
                  statusName = found.name;
                  statusColor = found.color;
                } else {
                  statusName = leadStatus;
                }
              } else if (typeof leadStatus === "object") {
                const found = activeStatuses.find(
                  (s: any) => s._id === leadStatus._id || s.slug === leadStatus.slug || s.name === leadStatus.name
                );
                if (found) {
                  statusName = found.name;
                  statusColor = found.color;
                } else {
                  statusName = leadStatus.name || "Unknown";
                  statusColor = leadStatus.color || "#94a3b8";
                }
              }
            }

            if (!statusMap[statusName]) {
              statusMap[statusName] = {
                name: statusName,
                leadCount: 0,
                leadValue: 0,
                color: statusColor,
              };
            }

            statusMap[statusName].leadCount += 1;
            statusMap[statusName].leadValue += Number(lead.leadValue || 0);
          });

          setLeadsByStatus(
            Object.values(statusMap).sort(
              (a: any, b: any) => b.leadCount - a.leadCount,
            ) as Array<{
              name: string;
              leadCount: number;
              leadValue: number;
              color: string;
            }>,
          );

          const limit = rawRes.data.length === 4 ? 2 : 5;
          const sortedLeads = rawRes.data
            .sort((a: any, b: any) => {
              const aDate = a.createdAt
                ? new Date(a.createdAt).getTime()
                : 0;
              const bDate = b.createdAt
                ? new Date(b.createdAt).getTime()
                : 0;
              return bDate - aDate;
            })
            .slice(0, limit);
          setTopDeals(sortedLeads);
        } else {
          setAllLeads([]);
          setTopDeals([]);
          setLeadsByStatus([]);
        }
      } catch (err) {
        console.error("Error fetching recent leads:", err);
        setAllLeads([]);
        setTopDeals([]);
        setLeadsByStatus([]);
      }

      try {
        await getrawdataSource(apiparams);
      } catch (e) {
        console.error("Error calling getrawdataSource:", e);
      }

      // Initialize sourcesMap from activeSources
      const sourcesMap: Record<string, {
        sourceName: string;
        leadCount: number;
        leadValueTotal: number;
        leadDates: string[];
        color: string;
        category: string[];
      }> = {};

      activeSources.forEach((src: any) => {
        sourcesMap[src.name] = {
          sourceName: src.name,
          leadCount: 0,
          leadValueTotal: 0,
          leadDates: [],
          color: src.color || "#1890ff",
          category: Array.isArray(src.category) ? src.category : [src.category],
        };
      });

      // Filter rawLeads to get sales raw leads
      const salesRawLeads = rawLeads.filter((lead: any) => {
        if (lead.category) {
          return Array.isArray(lead.category) ? lead.category.includes("Sales") : lead.category === "Sales";
        }
        return true;
      });

      salesRawLeads.forEach((lead: any) => {
        const srcName = lead.leadSource?.name || lead.sourceName || "Unknown";
        if (!sourcesMap[srcName]) {
          sourcesMap[srcName] = {
            sourceName: srcName,
            leadCount: 0,
            leadValueTotal: 0,
            leadDates: [],
            color: lead.leadSource?.color || "#94a3b8",
            category: ["Sales"],
          };
        }
        sourcesMap[srcName].leadCount += 1;
        sourcesMap[srcName].leadValueTotal += Number(lead.leadValue || 0);
        if (lead.createdAt) {
          sourcesMap[srcName].leadDates.push(lead.createdAt);
        }
      });

      const salesLeads = Object.values(sourcesMap);
      setSource(salesLeads);

      // --- Pie Chart ---
      let chartData = salesLeads
        .map((lead: any) => ({
          name: lead.sourceName || "Unknown",
          value: lead.leadCount || 0,
          leadValue: lead.leadValueTotal || 0, // extra info for inside label
          color: lead.color || "#1890ff",
          itemStyle: {
            color: lead.color || "#1890ff",
          },
        }))
        // ✅ Sort by leadCount (value) descending
        .sort((a: any, b: any) => b.value - a.value);

      if (chartData.length === 0) {
        chartData = [{ name: "No Data", value: 1, leadValue: 0, color: "#98FB98", itemStyle: { color: "#98FB98" } }];
      }
      

      console.log("Pie Chart Data:", chartData);
      const totalLeads = chartData.reduce(
        (sum: number, item: any) => sum + (item.value || 0),
        0,
      );
      const totalLeadValue = chartData.reduce(
        (sum: number, item: any) => sum + (item.leadValue || 0),
        0,
      );

      setLeadsByCategoryChartOptions({
        title: [
          {
            text: "Leads by Source",
            left: "left",
            textStyle: { fontSize: 16, fontWeight: 600 },
          },
          {
            // ✅ Show total counts below legend
            text: `{bold|Lead Total:} ${totalLeads.toLocaleString()}   |   {bold|Lead Value:} ₹ ${totalLeadValue.toLocaleString()}`,
            right: 10,
            bottom: 0,
            textStyle: {
              fontSize: 13,
              fontWeight: 500,
              color: "#333",
              rich: {
                bold: {
                  fontWeight: "bold",
                  color: "#000", // ✅ black & bold for labels
                },
              },
            },
          },
        ],
        tooltip: {
          trigger: "item",
          formatter: (params: any) => {
            return `${params.seriesName}<br/>
        ${params.name}: ${params.value} (${params.percent}%)<br/>
        Value: ₹${params.data.leadValue?.toLocaleString()}`;
          },
        },
        legend: {
          orient: "vertical",
          right: 0,
          top: "middle",
          formatter: (name: string) => {
            const item = chartData.find((d: any) => d.name === name);
            if (item) {
              return `${name} | ₹${item.leadValue?.toLocaleString()}`;
            }
            return name;
          },
          textStyle: { fontSize: 14, color: "#000" },
        },
        series: [
          {
            name: "Leads by Source",
            type: "pie",
            right: 4,
            radius: ["40%", "70%"],
            center: ["40%", "55%"],
            avoidLabelOverlap: false,
            label: {
              show: true,
              color: "#000",
              formatter: "{b}\n{c} ({d}%)",
              fontSize: 13,
              fontWeight: "bold",
            },
            data: chartData,
          },
        ],
      });

      // --- Growth & Leads Enrichment ---
      const now = dayjs();
      const todayStart = now.startOf("day");
      const thisMonthStart = now.startOf("month");
      const lastMonthStart = now.subtract(1, "month").startOf("month");
      const lastMonthEnd = now.subtract(1, "month").endOf("month");

      const enrichedLeads = salesLeads.map((lead: any) => {
        let filteredLeads = lead.leadCount || 0;
        let valueChange = 0;
        let growthPercentage = 0;

        if (currentTimeFilter === "today") {
          filteredLeads = lead.leadDates.filter((d: string) =>
            dayjs(d).isSame(todayStart, "day"),
          ).length;
        } else if (currentTimeFilter === "thisMonth") {
          filteredLeads = lead.leadDates.filter(
            (d: string) =>
              dayjs(d).isAfter(thisMonthStart) ||
              dayjs(d).isSame(thisMonthStart, "day"),
          ).length;
        } else if (currentTimeFilter === "lastMonth") {
          filteredLeads = lead.leadDates.filter(
            (d: string) =>
              (dayjs(d).isAfter(lastMonthStart) ||
                dayjs(d).isSame(lastMonthStart, "day")) &&
              (dayjs(d).isBefore(lastMonthEnd) ||
                dayjs(d).isSame(lastMonthEnd, "day")),
          ).length;
        } else if (
          currentTimeFilter === "custom" &&
          currentStartDate &&
          currentEndDate
        ) {
          filteredLeads = lead.leadDates.filter(
            (d: string) =>
              (dayjs(d).isAfter(dayjs(currentStartDate)) ||
                dayjs(d).isSame(dayjs(currentStartDate), "day")) &&
              (dayjs(d).isBefore(dayjs(currentEndDate)) ||
                dayjs(d).isSame(dayjs(currentEndDate), "day")),
          ).length;
        } else {
          filteredLeads = lead.leadCount || 0;
        }

        if (currentTimeFilter === "lastMonth") {
          valueChange = 0;
          growthPercentage = 0;
        } else {
          const thisMonthLeads = lead.leadDates.filter(
            (d: string) =>
              dayjs(d).isAfter(thisMonthStart) ||
              dayjs(d).isSame(thisMonthStart, "day"),
          ).length;
          const lastMonthLeads = lead.leadDates.filter(
            (d: string) =>
              (dayjs(d).isAfter(lastMonthStart) ||
                dayjs(d).isSame(lastMonthStart, "day")) &&
              (dayjs(d).isBefore(lastMonthEnd) ||
                dayjs(d).isSame(lastMonthEnd, "day")),
          ).length;
          valueChange = thisMonthLeads - lastMonthLeads;
          growthPercentage =
            lastMonthLeads > 0
              ? Number(((valueChange / lastMonthLeads) * 100).toFixed(1))
              : thisMonthLeads > 0
                ? 100
                : 0;
        }

        if (
          currentTimeFilter === "custom" &&
          currentStartDate &&
          currentEndDate
        ) {
          const prevStartDate = dayjs(currentStartDate).subtract(
            dayjs(currentEndDate).diff(dayjs(currentStartDate), "day"),
            "day",
          );
          const prevEndDate = dayjs(currentStartDate).subtract(1, "day");
          const currentLeads = lead.leadDates.filter(
            (d: string) =>
              (dayjs(d).isAfter(dayjs(currentStartDate)) ||
                dayjs(d).isSame(dayjs(currentStartDate), "day")) &&
              (dayjs(d).isBefore(dayjs(currentEndDate)) ||
                dayjs(d).isSame(dayjs(currentEndDate), "day")),
          ).length;
          const prevLeads = lead.leadDates.filter(
            (d: string) =>
              (dayjs(d).isAfter(prevStartDate) ||
                dayjs(d).isSame(prevStartDate, "day")) &&
              (dayjs(d).isBefore(prevEndDate) ||
                dayjs(d).isSame(prevEndDate, "day")),
          ).length;
          valueChange = currentLeads - prevLeads;
          growthPercentage =
            prevLeads > 0
              ? Number(((valueChange / prevLeads) * 100).toFixed(1))
              : currentLeads > 0
                ? 100
                : 0;
        }

        return {
          ...lead,
          filteredLeads,
          valueChange,
          growthPercentage,
        };
      });

      const sortedLeads = [...enrichedLeads].sort((a: any, b: any) => {
        const aVal = a.filteredLeads || 0;
        const bVal = b.filteredLeads || 0;

        if (aVal === 0 && bVal === 0) return 0;
        if (aVal === 0) return 1;
        if (bVal === 0) return -1;

        return bVal - aVal;
      });

      // --- Bar Chart Data ---
      // const barChartCategories = sortedLeads.map((lead: any) => lead.sourceName || 'Unknown');
      // const barChartValues = sortedLeads.map((lead: any) => lead.filteredLeads || 0);
      // const growthPercentages = sortedLeads.map((lead: any) =>
      //     lead.growthPercentage >= 0
      //         ? `↑ ${Math.abs(lead.growthPercentage)}%`
      //         : `↓ ${Math.abs(lead.growthPercentage)}%`
      // );

      // setLeadsBarChartOptions({
      //     title: {
      //         left: 'center',
      //         textStyle: { fontSize: 16, fontWeight: 600 }
      //     },
      //     grid: { left: '5%', right: '10%', containLabel: true },
      //     xAxis: { type: 'value', show: false, splitLine: { show: false } },
      //     yAxis: [
      //         {
      //             type: 'category',
      //             data: barChartCategories,
      //             axisTick: { show: false },
      //             axisLine: { show: true },
      //             axisLabel: { fontSize: 14 },
      //             inverse: true
      //         },
      //         {
      //             type: 'category',
      //             position: 'right',
      //             offset: 50,
      //             data: growthPercentages,
      //             axisLine: { show: false },
      //             axisTick: { show: false },
      //             axisLabel: {
      //                 fontSize: 14,
      //                 fontWeight: 'bold',
      //                 color: (val: string) => val.includes('↓') ? 'red' : 'green'
      //             },
      //             inverse: true
      //         }
      //     ],
      //     series: [
      //         {
      //             type: 'bar',
      //             data: barChartValues,
      //             barWidth: 30,
      //             barCategoryGap: '0%',
      //             itemStyle: { color: '#1890ff' },
      //             label: {
      //                 show: true,
      //                 position: 'right',
      //                 distance: 8,
      //                 formatter: '{c}',
      //                 fontSize: 14,
      //                 color: '#000'
      //             }
      //         }
      //     ]
      // });
      // --- Bar Chart Data ---
      // 1. Sort a fresh copy of the leads based on leadValueTotal (Highest to Lowest)
      const valueSortedLeads = [...sortedLeads].sort((a: any, b: any) => {
        const valA = a.leadValueTotal || 0;
        const valB = b.leadValueTotal || 0;
        return valB - valA;
      });

      // 2. Map the data using the NEW valueSortedLeads array
      const barChartCategories = valueSortedLeads.map(
        (lead: any) => lead.sourceName || "Unknown",
      );
      const barChartCounts = valueSortedLeads.map(
        (lead: any) => lead.filteredLeads || 0,
      );
      const barChartValues = valueSortedLeads.map(
        (lead: any) => lead.leadValueTotal || 0,
      );
      const growthPercentages = valueSortedLeads.map((lead: any) =>
        lead.growthPercentage >= 0
          ? `↑ ${Math.abs(lead.growthPercentage)}%`
          : `↓ ${Math.abs(lead.growthPercentage)}%`,
      );

      // ... keep your setLeadsBarChartOptions exactly the same as it was
      setLeadsBarChartOptions({
        title: {
          text: "Leads by Source",
          left: "center",
          textStyle: { fontSize: 16, fontWeight: 600 },
        },
        grid: {
          left: "15%",
          right: "15%",
          bottom: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          show: true,
          splitLine: { show: false },
          axisLabel: {
            // Formats the bottom axis numbers as currency
            formatter: (val: number) => `₹${val.toLocaleString("en-IN")}`,
          },
        },
        yAxis: [
          {
            type: "category",
            data: barChartCategories,
            axisTick: { show: false },
            axisLine: { show: true },
            axisLabel: { fontSize: 14 },
            inverse: true,
          },
          {
            type: "category",
            position: "right",
            offset: 105,
            data: growthPercentages,
            axisLine: { show: false },
            axisTick: { show: false },
            axisLabel: {
              fontSize: 14,
              fontWeight: "bold",
              color: (val: string) => (val.includes("↓") ? "red" : "green"),
            },
            inverse: true,
          },
        ],
        series: [
          // 1. The Main Blue Bar (Length based on Lead Value)
          {
            type: "bar",
            name: "Lead Value",
            data: barChartValues, // 👈 Bar length is now Lead Value
            barWidth: 30,
            itemStyle: { color: "#1890ff" },
            label: {
              show: true,
              position: "right", // 👈 Shows at the "last" (end of the bar)
              distance: 28,
              formatter: (params: any) => {
                return `₹${params.value.toLocaleString("en-IN")}`;
              },
              fontSize: 12,
              color: "#333",
              fontWeight: "bold",
              backgroundColor: "rgba(255, 255, 255, 0.9)", // White box for currency
              padding: [4, 8],
              borderRadius: 4,
              borderColor: "#ddd",
              borderWidth: 1,
            },
          },
          // 2. The Transparent Bar (Shows Lead Count inside the left side of the bar)
          {
            type: "bar",
            name: "Lead Count",
            data: barChartValues, // Must match so it perfectly overlaps
            barWidth: 30,
            barGap: "-100%",
            itemStyle: {
              color: "transparent",
              borderColor: "transparent",
            },
            label: {
              show: true,
              position: "insideLeft", // 👈 Shows Lead Count at the start of the bar
              distance: 10,
              formatter: (params: any) => {
                const leadIndex = params.dataIndex;
                const count = barChartCounts[leadIndex]; // Pulls from the count array
                return `${count}`;
              },
              fontSize: 13,
              color: "#080808", // White text to stand out on the blue bar
              fontWeight: "bold",
            },
            tooltip: { show: false },
            z: 5,
          },
        ],
      });

      // --- Collect unique dates across all sources ---
      // --- SINGLE LINE CHART WITH DETAILED TOOLTIP LOGIC ---

      // 1. Collect all unique dates across all sources
      const allDates = Array.from(
        new Set(
          enrichedLeads.flatMap((lead: any) =>
            (lead.leadDates || []).map((d: string) =>
              dayjs(d).format("YYYY-MM-DD"),
            ),
          ),
        ),
      ).sort();

      // Array of colors to use for the dots inside the tooltip box
      const tooltipColors = [
        "#5470c6",
        "#91cc75",
        "#fac858",
        "#ee6666",
        "#73c0de",
        "#3ba272",
        "#fc8452",
        "#9a60b4",
      ];

      // 2. Calculate the combined data AND keep the breakdown for the tooltip box
      const chartValues = allDates.map((date) => {
        let dailyTotal = 0;
        const breakdown: any[] = []; // This will hold data for the hover box

        enrichedLeads.forEach((lead: any, index: number) => {
          // Skip "Other" source
          if (lead.sourceName === "Other") {
            return; // Skip this iteration
          }

          const dailyCount = (lead.leadDates || []).filter(
            (d: string) => dayjs(d).format("YYYY-MM-DD") === date,
          ).length;

          const avgValue =
            lead.leadCount > 0
              ? (lead.leadValueTotal || 0) / lead.leadCount
              : 0;
          const sourceValue = dailyCount * avgValue;

          dailyTotal += sourceValue;

          // Save this source's details to show in the hover box later
          breakdown.push({
            name: lead.sourceName || "Unknown",
            value: sourceValue,
            color: tooltipColors[index % tooltipColors.length],
          });
        });

        // ECharts automatically graphs the 'value' property,
        // but lets us access 'breakdown' in the tooltip!
        return {
          value: dailyTotal,
          breakdown: breakdown,
        };
      });

      // 3. Find max value for Y-axis scaling
      const maxValue =
        chartValues.length > 0
          ? Math.max(...chartValues.map((v) => v.value))
          : 0;

      // 4. Set Chart Options
      setLeadsLineChartOptions({
        title: {
          text: "Total Lead Value Trend",
          left: "center",
          textStyle: { fontSize: 16, fontWeight: 600 },
        },
        legend: { show: false }, // Hidden since there is only 1 line
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          borderColor: "#e2e8f0",
          borderWidth: 1,
          textStyle: { color: "#1f2937" },
          formatter: (params: any) => {
            const item = params[0]; // The single line's data point
            const date = item.axisValue;
            const totalValue = item.value;
            const breakdown = item.data.breakdown; // Our custom breakdown array

            // Start building the tooltip HTML box
            let tooltipHtml = `<b style="font-size:14px; display:block; margin-bottom:8px;">${date}</b>`;

            // Add each source's breakdown with colorful dots
            breakdown.forEach((source: any) => {
              // Formatting updated here to remove decimals
              tooltipHtml += `
                    <div style="display:flex; justify-content:space-between; gap:24px; margin-bottom:4px;">
                        <span style="display:flex; align-items:center;">
                            <span style="display:inline-block; margin-right:8px; border-radius:50%; width:10px; height:10px; background-color:${source.color};"></span>
                            ${source.name}:
                        </span> 
                        <span>₹${source.value.toLocaleString("en-IN", { maximumFractionDigits: 0 })}</span>
                    </div>`;
            });

            // Add a separator line and the Grand Total at the bottom of the box
            // Formatting updated here to remove decimals
            tooltipHtml += `
                <hr style="margin:8px 0; border:0; border-top:1px solid #e5e7eb;" />
                <div style="display:flex; justify-content:space-between; gap:24px;">
                    <b>Total:</b>
                    <b>₹${totalValue.toLocaleString("en-IN", { maximumFractionDigits: 0 })}</b>
                </div>`;

            return tooltipHtml;
          },
        },
        grid: { left: "5%", right: "5%", bottom: "12%", containLabel: true },
        xAxis: {
          type: "category",
          data: allDates,
          boundaryGap: false,
          axisLabel: { rotate: allDates.length > 7 ? 40 : 0 },
          splitLine: {
            show: true,
            lineStyle: { type: "dashed", color: "#f3f4f6" },
          },
        },
        yAxis: {
          type: "value",
          name: "Lead Value (₹)",
          max: maxValue > 0 ? maxValue + maxValue * 0.1 : undefined,
          splitLine: {
            show: true,
            lineStyle: { type: "dashed", color: "#e5e7eb" },
          },
          axisLabel: {
            // Formatting updated here to remove decimals
            formatter: (val: number) =>
              `₹${val.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`,
          },
        },
        series: [
          {
            name: "Total Lead Value",
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 8,
            data: chartValues, // This passes the object with both 'value' and 'breakdown'
            lineStyle: { width: 3, color: "#3b82f6" },
            itemStyle: { color: "#3b82f6" },
            areaStyle: { opacity: 0.15, color: "#3b82f6" }, // Optional gradient look
          },
        ],
      });
      // --- Cards ---
      const dynamicMetrics = enrichedLeads
        .map((lead: any) => {
          const avgValue = lead.leadCount > 0 ? (lead.leadValueTotal || 0) / lead.leadCount : 0;
          const filteredValue = lead.filteredLeads * avgValue;
          return {
            title: lead.sourceName || "Unknown",
            Total: lead.filteredLeads || 0,
            filteredLeads: lead.filteredLeads || 0,
            valueChange: Math.abs(lead.valueChange),
            leadValue: filteredValue || 0,
            color: lead.color || "#1890ff",
            change: {
              text: `${Math.abs(lead.growthPercentage)}%`,
              style: {
                color: lead.growthPercentage >= 0 ? "#32CD32" : "#FF4500",
                fontWeight: "bold",
              },
              icon:
                lead.growthPercentage >= 0 ? (
                  <ArrowUpOutlined style={{ color: "#32CD32" }} />
                ) : (
                  <ArrowDownOutlined style={{ color: "#FF4500" }} />
                ),
            },
          };
        })
        // ✅ Sort by Total (filteredLeads) descending
        .sort((a: any, b: any) => b.Total - a.Total);
      const totalLeadCount = enrichedLeads.reduce(
        (sum: number, lead: any) => sum + (lead.filteredLeads || 0),
        0,
      );

      const totalLeadValueSum = enrichedLeads.reduce(
        (sum: number, lead: any) => {
          const avgValue = lead.leadCount > 0 ? (lead.leadValueTotal || 0) / lead.leadCount : 0;
          const filteredValue = lead.filteredLeads * avgValue;
          return sum + filteredValue;
        },
        0,
      );

      const totalChangeVal = enrichedLeads.reduce(
        (sum: number, lead: any) => sum + (lead.valueChange || 0),
        0,
      );

      setMetrics(dynamicMetrics);
      setTotalLeads(totalLeadCount);
      setTotalLeadValue(totalLeadValueSum);
      setTotalLeadsChange(totalChangeVal);
    } catch (err) {
      console.error("Error in fetchLeadsSource:", err);
      message.error("Failed to fetch leads");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const init = async () => {
      const activeStatuses = await fetchStatuses();
      const activeSources = await fetchSource();
      const defaultId = localStorage.getItem("defaultLeadAnalyticsFilterId");
      if (!defaultId) {
        await fetchLeadsSource({}, activeStatuses, activeSources);
      }
      await filterFetch(activeStatuses, activeSources);
    };
    init();
  }, []);

  const FILTER_STORAGE_KEY = "AnalyticsFilter";

  // const getFavouriteFilters = (): any[] => {
  //     const saved = localStorage.getItem(LOCAL_STORAGE_KEY);
  //     return saved ? JSON.parse(saved) : [];
  // };

  // const saveFavouriteFilters = (filters: any[]) => {
  //     localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(filters));
  // };

  // const addFavouriteFilter = (fav: any) => {
  //     if (!fav.label.trim()) return;

  //     const filters = getFavouriteFilters();
  //     filters.push(fav);
  //     saveFavouriteFilters(filters);
  //     setFavouriteFilters(filters);
  //     message.success("Favorite filter saved!");
  // };

  // const deleteFavouriteFilter = (id: number) => {
  //     const filters = getFavouriteFilters().filter(f => f.id !== id);
  //     saveFavouriteFilters(filters);
  //     setFavouriteFilters(filters);
  //     message.success("Filter deleted!");
  // };

  // const applyFavouriteFilter = (filter: any) => {
  //     setStatusFilter(filter.status || []);
  //     setTimeFilter(filter.timeFilter);
  //     setStartDate(filter.startDate ? moment(filter.startDate) : null);
  //     setEndDate(filter.endDate ? moment(filter.endDate) : null);

  //     fetchLeadsSource({
  //         timeFilter: filter.timeFilter,
  //         startDate: filter.startDate,
  //         endDate: filter.endDate,
  //         status: filter.status || null,
  //         page: 1,
  //     });
  // };

  // useEffect(() => {
  //     const savedFilters = getFavouriteFilters();
  //     setFavouriteFilters(savedFilters);
  // }, []);

  const filterFetch = async (loadedStatuses?: any[], loadedSources?: any[]) => {
    try {
      const localFilters = getFavouriteFilters(); // ✅ already only Analytics if you fixed earlier
      if (isDeveloper) {
        return;
      }

      const response = await getFilter(); // API call

      // ✅ filter server response by Analytics type
      const serverFilters = Array.isArray(response?.data)
        ? response.data.filter((res: any) => res.type === "Analytics")
        : response?.data?.type === "Analytics"
          ? [response.data]
          : [];

      // ✅ only keep filters for current user
      const userId = authData?.user?._id;
      const userFilters = serverFilters.filter(
        (sf: any) => sf.userId === userId,
      );

      // ✅ merge local + server (avoid duplicates by _id)
      const mergedFilters = [
        ...localFilters,
        ...userFilters.filter(
          (sf: any) => !localFilters.some((lf) => lf._id === sf._id),
        ),
      ];

      // ✅ save merged into localStorage
      saveFavouriteFilters(mergedFilters);
      setFavouriteFilters(mergedFilters);

      // ✅ Apply default filter on load
      const defaultId = localStorage.getItem("defaultLeadAnalyticsFilterId");
      if (defaultId) {
        const defaultFilter = mergedFilters.find(
          (f: any) => f._id === defaultId,
        );
        if (defaultFilter && selectedFav !== defaultFilter._id) {
          setSelectedFav(defaultFilter._id);
          localStorage.setItem("selectedFavId", defaultFilter._id);

          const params = {
            source: defaultFilter.source || [],
            sourceid: defaultFilter.sourceid || [],
            priority: defaultFilter.priority || [],
            country: defaultFilter.country || [],
            status: defaultFilter.status || [],
            owner: defaultFilter.owner || [],
            tags: defaultFilter.tags || [],
            timeFilter: defaultFilter.time || null,
            startDate: defaultFilter.startDate || null,
            endDate: defaultFilter.endDate || null,
            followupdate: defaultFilter.followupdate || null,
            followupstartDate: defaultFilter.followupstartDate || null,
            followupendDate: defaultFilter.followupendDate || null,
            page: 1,
          };
          fetchLeadsSource(params, loadedStatuses, loadedSources);
        } else if (!defaultFilter) {
          fetchLeadsSource({}, loadedStatuses, loadedSources);
        }
      }
    } catch (error) {
      console.error("Failed to fetch filters:", error);
    }
  };

  const setAsDefaultFilter = (e: React.MouseEvent, fav: any) => {
    e.stopPropagation();
    if (defaultFilterId === fav._id) {
      localStorage.removeItem("defaultLeadAnalyticsFilterId");
      setDefaultFilterId(null);
      message.success(`'${fav.name}' removed from default.`);
    } else {
      localStorage.setItem("defaultLeadAnalyticsFilterId", fav._id);
      setDefaultFilterId(fav._id);
      message.success(`'${fav.name}' set as default filter!`);
      if (selectedFav !== fav._id) {
        applyFavouriteFilter(fav);
      }
    }
  };

  const iconKeys = Object.keys(Icons).filter(
    (key) => key.endsWith("Outlined"), // only outlined icons (you can adjust)
  );
  const options = iconKeys.map((key) => {
    const IconComp = (Icons as any)[key];
    return {
      label: (
        <span>
          <IconComp style={{ marginRight: 8 }} /> {key}
        </span>
      ),
      value: key,
    };
  });

  // const timeFilterOptions = [
  //     { value: 'today', label: 'Today' },
  //     { value: "yesterday", label: "Yesterday" },
  //     { value: "last7days", label: "Last 7 Days" },
  //     { value: 'thisMonth', label: 'This Month' },
  //     { value: 'lastMonth', label: 'Last Month' },

  // ];
  // const FilterMenu = (
  //     <div
  //         style={{
  //             display: "grid",
  //             gridTemplateColumns: "repeat(3, 1fr)",
  //             minWidth: "300px",
  //             background: "linear-gradient(145deg, #ffffff, #f8fafc)",
  //             boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  //             borderRadius: "12px",
  //             overflow: "hidden",
  //             padding: "16px",
  //             overflowY: "auto",
  //             gap: "12px",
  //         }}
  //         className="filter-menu"
  //     >
  //         {/* Status Filter */}
  //         <div
  //             style={{
  //                 padding: "12px",
  //                 borderRight: "1px solid #e5e7eb",
  //                 height: "300px",
  //                 display: "flex",
  //                 flexDirection: "column",
  //             }}
  //         >
  //             <div
  //                 style={{
  //                     display: "flex",
  //                     alignItems: "center",
  //                     justifyContent: "space-between",
  //                     fontWeight: 600,
  //                     fontSize: "16px",
  //                     color: "#1f2937",
  //                     paddingBottom: "8px",
  //                     borderBottom: "2px solid #e5e7eb",
  //                     backgroundColor: "#fff",
  //                     position: "sticky",
  //                     top: 0,
  //                     zIndex: 10,
  //                 }}
  //             >
  //                 <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
  //                     <FilterOutlined style={{ color: "#3b82f6" }} />
  //                     Status Filter
  //                 </span>
  //                 <Button
  //                     type="link"
  //                     size="small"
  //                     style={{ padding: 0, color: "#ef4444" }}
  //                     onClick={() => {
  //                         setStatusFilter([]);
  //                         setPage(1);
  //                         fetchLeadsSource({
  //                             status: "",
  //                             page: 1,
  //                         });
  //                     }}
  //                 >
  //                     Clear
  //                 </Button>
  //             </div>
  //             <div
  //                 style={{
  //                     marginTop: "8px",
  //                     overflowY: "auto",
  //                     flex: 1,
  //                     display: "flex",
  //                     flexDirection: "column",
  //                     gap: "6px",
  //                 }}
  //             >
  //                 {statusOptions.map((opt: any) => (
  //                     <div
  //                         key={opt.value}
  //                         style={{
  //                             padding: "8px 12px",
  //                             cursor: "pointer",
  //                             borderRadius: "6px",
  //                             display: "flex",
  //                             alignItems: "center",
  //                             gap: "8px",
  //                             transition: "all 0.2s ease",
  //                             backgroundColor: statusFilter.includes(opt.value)
  //                                 ? "#e6f7ff"
  //                                 : "transparent",
  //                         }}
  //                         onClick={() => handleStatusFilterChange(opt.value)}
  //                         onMouseEnter={(e) =>
  //                         (e.currentTarget.style.backgroundColor = statusFilter.includes(opt.value)
  //                             ? "#e6f7ff"
  //                             : "#f1f5f9")
  //                         }
  //                         onMouseLeave={(e) =>
  //                         (e.currentTarget.style.backgroundColor = statusFilter.includes(opt.value)
  //                             ? "#e6f7ff"
  //                             : "transparent")
  //                         }
  //                     >
  //                         {opt.label}
  //                     </div>
  //                 ))}
  //             </div>
  //         </div>

  //         {/* Time Filter */}
  //         <div
  //             style={{
  //                 padding: "12px",
  //                 borderRight: "1px solid #e5e7eb",
  //             }}
  //         >
  //             <div
  //                 style={{
  //                     display: "flex",
  //                     alignItems: "center",
  //                     justifyContent: "space-between",
  //                     marginBottom: "12px",
  //                     fontWeight: 600,
  //                     fontSize: "16px",
  //                     color: "#1f2937",
  //                     borderBottom: "2px solid #e5e7eb",
  //                     paddingBottom: "8px",
  //                 }}
  //             >
  //                 <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
  //                     <ClockCircleOutlined style={{ color: "#10b981" }} />
  //                     Time Filter
  //                 </span>
  //                 <Button
  //                     type="link"
  //                     size="small"
  //                     style={{ padding: 0, color: "#ef4444" }}
  //                     onClick={() => {
  //                         setTimeFilter(undefined);
  //                         setStartDate(null);
  //                         setEndDate(null);
  //                         setTempStartDate(null);
  //                         setTempEndDate(null);
  //                         setPage(1);
  //                         fetchLeadsSource({
  //                             timeFilter: undefined,
  //                             startDate: null,
  //                             endDate: null,
  //                             status: statusFilter || null,
  //                             page: 1,
  //                         });
  //                     }}
  //                 >
  //                     Clear
  //                 </Button>
  //             </div>
  //             <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
  //                 {timeFilterOptions.map((opt: any) => (
  //                     <div
  //                         key={opt.value}
  //                         style={{
  //                             padding: "5px 5px",
  //                             cursor: "pointer",
  //                             borderRadius: "6px",
  //                             fontSize: "14px",
  //                             transition: "all 0.2s ease",
  //                             backgroundColor:
  //                                 timeFilter === opt.value ? "#e6f7ff" : "transparent",
  //                         }}
  //                         onClick={() => {
  //                             setTimeFilter(opt.value);
  //                             setPage(1);
  //                             if (opt.value !== "custom") {
  //                                 setStartDate(null);
  //                                 setEndDate(null);
  //                                 setTempStartDate(null);
  //                                 setTempEndDate(null);
  //                                 fetchLeadsSource({
  //                                     timeFilter: opt.value,
  //                                     startDate: null,
  //                                     endDate: null,
  //                                     status: statusFilter || null,
  //                                     page: 1,
  //                                 });
  //                             }
  //                         }}
  //                         onMouseEnter={(e) =>
  //                         (e.currentTarget.style.backgroundColor =
  //                             timeFilter === opt.value ? "#e6f7ff" : "#f1f5f9")
  //                         }
  //                         onMouseLeave={(e) =>
  //                         (e.currentTarget.style.backgroundColor =
  //                             timeFilter === opt.value ? "#e6f7ff" : "transparent")
  //                         }
  //                     >
  //                         {opt.label}
  //                     </div>
  //                 ))}
  //                 <div
  //                     style={{
  //                         padding: "8px 12px",
  //                         cursor: "pointer",
  //                         borderRadius: "6px",
  //                         fontSize: "14px",
  //                         marginTop: "8px",
  //                         background: "#f1f5f9",
  //                         transition: "all 0.2s ease",
  //                     }}
  //                     onClick={() => setShowRangePicker(true)}
  //                     onMouseEnter={(e) =>
  //                         (e.currentTarget.style.backgroundColor = "#e2e8f0")
  //                     }
  //                     onMouseLeave={(e) =>
  //                         (e.currentTarget.style.backgroundColor = "#f1f5f9")
  //                     }
  //                 >
  //                     Custom Range
  //                 </div>
  //             </div>
  //         </div>

  //         {/* Favorites */}
  //         <div style={{ padding: "12px" }}>
  //             <h4
  //                 style={{
  //                     marginBottom: "12px",
  //                     fontSize: "16px",
  //                     fontWeight: 600,
  //                     color: "#1f2937",
  //                     borderBottom: "2px solid #e5e7eb",
  //                     paddingBottom: "8px",
  //                 }}
  //             >
  //                 <i className="fas fa-star mr-2 text-yellow-500"></i> Favorites
  //             </h4>
  //             <div style={{ display: "flex", gap: "6px" }}>
  //                 <input
  //                     value={newFavName}
  //                     onChange={(e) => setNewFavName(e.target.value)}
  //                     placeholder="Enter favorite name"
  //                     style={{
  //                         flex: 1,
  //                         padding: "6px 8px",
  //                         borderRadius: "6px",
  //                         border: "1px solid #d1d5db",
  //                     }}
  //                 />
  //                 <Button
  //                     className="allbuttons"
  //                     style={{ color: "white" }}
  //                     onClick={() => {
  //                         if (!newFavName) return;
  //                         const fav = {
  //                             id: Date.now(),
  //                             label: newFavName,
  //                             status: statusFilter,
  //                             timeFilter,
  //                             startDate: startDate ? startDate.format("YYYY-MM-DD") : null,
  //                             endDate: endDate ? endDate.format("YYYY-MM-DD") : null,
  //                         };
  //                         addFavouriteFilter(fav);
  //                         setNewFavName("");
  //                     }}
  //                 >
  //                     Save
  //                 </Button>
  //             </div>
  //         </div>

  //         {/* Custom Range Modal */}
  //         {showRangePicker && (
  //             <div
  //                 style={{
  //                     position: "fixed",
  //                     top: "50%",
  //                     left: "50%",
  //                     transform: "translate(-50%, -50%)",
  //                     zIndex: 1500,
  //                     background: "#fff",
  //                     padding: "20px",
  //                     boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
  //                     borderRadius: "12px",
  //                     width: "90%",
  //                     maxWidth: "400px",
  //                 }}
  //             >
  //                 <h4
  //                     style={{
  //                         fontSize: "16px",
  //                         fontWeight: 600,
  //                         color: "#1f2937",
  //                         marginBottom: "16px",
  //                     }}
  //                 >
  //                     Select Date Range
  //                 </h4>
  //                 <DatePicker.RangePicker
  //                     value={
  //                         tempStartDate && tempEndDate ? [tempStartDate, tempEndDate] : null
  //                     }
  //                     onChange={(dates) => {
  //                         setTempStartDate(dates ? dates[0] : null);
  //                         setTempEndDate(dates ? dates[1] : null);
  //                     }}
  //                     format="YYYY-MM-DD"
  //                     style={{ marginBottom: "16px", width: "100%" }}
  //                     allowClear={false}
  //                     getPopupContainer={(triggerNode) => document.body}
  //                     popupStyle={{ zIndex: 2000 }}
  //                 />
  //                 <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
  //                     <Button
  //                         onClick={() => {
  //                             setShowRangePicker(false);
  //                             setTempStartDate(null);
  //                             setTempEndDate(null);
  //                         }}
  //                         style={{ borderRadius: "6px" }}
  //                     >
  //                         Cancel
  //                     </Button>
  //                     <Button
  //                         className="allbuttons"
  //                         onClick={() => {
  //                             if (tempStartDate && tempEndDate) {
  //                                 setStartDate(tempStartDate);
  //                                 setEndDate(tempEndDate);
  //                                 setTimeFilter("custom");
  //                                 setShowRangePicker(false);
  //                                 setPage(1);
  //                                 fetchLeadsSource({
  //                                     timeFilter: "custom",
  //                                     startDate: tempStartDate.format("YYYY-MM-DD"),
  //                                     endDate: tempEndDate.format("YYYY-MM-DD"),
  //                                     status: statusFilter || null,
  //                                     page: 1,
  //                                 });
  //                             }
  //                         }}
  //                         disabled={!tempStartDate || !tempEndDate}
  //                         style={{
  //                             background: "#3b82f6",
  //                             borderColor: "#3b82f6",
  //                             borderRadius: "6px",
  //                             color: "white"
  //                         }}
  //                     >
  //                         Apply
  //                     </Button>
  //                 </div>
  //             </div>
  //         )}

  //         <style>{`
  //             @media (max-width: 768px) {
  //                 .filter-menu {
  //                     grid-template-columns: 1fr !important;
  //                     min-width: 100% !important;
  //                 }
  //                 .filter-menu > div {
  //                     border-right: none !important;
  //                     border-bottom: 1px solid #e5e7eb !important;
  //                 }
  //                 .filter-menu > div:last-child {
  //                     border-bottom: none !important;
  //                 }
  //             }
  //         `}</style>
  //     </div>
  // );

  const timeFilterOptions = [
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" },
    { value: "last7days", label: "Last 7 Days" },
    { value: "thisMonth", label: "This Month" },
    { value: "lastMonth", label: "Last Month" },
    { value: "Last3Month", label: "Last 3 Month" },
    { value: "Last6Month", label: "Last 6 Month" },
    ...(startDate && endDate
      ? [
          {
            value: "custom",
            label: `${startDate.format("MMM D")} - ${endDate.format("MMM D")}`,
            startDate: startDate.format("DD-MM-YYYY"),
            endDate: endDate.format("DD-MM-YYYY"),
          },
        ]
      : [
          {
            value: "custom",
            label: "Custom Range",
            startDate: null,
            endDate: null,
          },
        ]),
  ];
  const followupFilterOptions = [
    { value: "followupToday", label: "Today" },
    { value: "followupYesterday", label: "Yesterday" },
    { value: "followupLast7Days", label: "Last 7 Days" },
    { value: "followupThisMonth", label: "This Month" },
    { value: "followupLastMonth", label: "Last Month" },
    { value: "followupLast3Month", label: "Last 3 Month" },
    { value: "followupLast6Month", label: "Last 6 Month" },
    ...(followupstartDate && followupendDate
      ? [
          {
            value: "followupCustom",
            label: `${followupstartDate.format("MMM D")} - ${followupendDate.format("MMM D")}`,
            followupstartDate: followupstartDate.format("DD-MM-YYYY"),
            followupendDate: followupendDate.format("DD-MM-YYYY"),
          },
        ]
      : [
          {
            value: "followupCustom",
            label: "Custom Range",
            followupstartDate: null,
            followupendDate: null,
          },
        ]),
  ];

  // --- localStorage helpers ---
  const getFavouriteFilters = (): any[] => {
    try {
      const saved = localStorage.getItem(FILTER_STORAGE_KEY);
      const parsed = saved ? JSON.parse(saved) : [];
      return parsed.filter((f: any) => f.type === "Analytics");
    } catch (error) {
      console.error(
        "Failed to parse favourite filters from localStorage",
        error,
      );
      return [];
    }
  };

  const slugify = (text: string) =>
    text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(/[^\w\-]+/g, "") // Remove special chars
      .replace(/\-\-+/g, "-");

  const applyFavouriteFilter = (fav: any) => {
    // ✅ if already selected, unselect (toggle off)
    if (selectedFav === fav._id) {
      setSelectedFav(null);
      localStorage.removeItem("selectedFavId");

      // Reset filters when unselecting
      fetchLeadsSource({
        page: 1,
      });

      navigate("/leadsAnalytics"); // optional: reset URL
      return;
    }

    // ✅ set new selected
    setSelectedFav(fav._id);
    localStorage.setItem("selectedFavId", fav._id);

    const params = {
      source: fav.source || [],
      sourceid: fav.sourceid || [],
      priority: fav.priority || [],
      country: fav.country || [],
      status: fav.status || [],
      owner: fav.owner || [],
      tags: fav.tags || [],
      timeFilter: fav.time || null,
      startDate: fav.startDate || null,
      endDate: fav.endDate || null,
      followupdate: fav.followupdate || null,
      followupstartDate: fav.followupstartDate || null,
      followupendDate: fav.followupendDate || null,
      page: 1,
    };

    fetchLeadsSource(params);

    // Optional: update URL
    const slug = slugify(fav.name);
    navigate(`/leadsAnalytics?slug=${slug}`);
  };

  const deleteFavouriteFilter = async (id: any) => {
    try {
      await deleteFilter(id);

      const filters = getFavouriteFilters().filter((f) => f._id !== id);
      saveFavouriteFilters(filters);
      setFavouriteFilters(filters);

      // ✅ reset selectedFav if deleted
      if (selectedFav === id) {
        setSelectedFav(null);
        localStorage.removeItem("selectedFavId");
      }

      message.success("Favourite filter deleted!");
    } catch (error) {
      console.error("Failed to delete filter:", error);
      message.error("Failed to delete favourite filter!");
    }
  };

  const addFavouriteFilter = async (fav: any) => {
    if (!fav.name.trim()) {
      setError("Please enter favorite name!");
      return;
    }
    setError("");

    const filters = getFavouriteFilters();

    const payload = {
      type: "Analytics",
      userId: userId || null,
      icon: fav.icon || "",
      name: fav.name,
      source: Array.isArray(selectedSource)
        ? selectedSource
        : selectedSource
          ? [selectedSource]
          : [],
      priority: Array.isArray(selectedPriority)
        ? selectedPriority
        : selectedPriority
          ? [selectedPriority]
          : [],
      country: Array.isArray(selectedCountry)
        ? selectedCountry
        : selectedCountry
          ? [selectedCountry]
          : [],
      status: Array.isArray(selectedStatus)
        ? selectedStatus
        : selectedStatus
          ? [selectedStatus]
          : [],
      sourceid: Array.isArray(selectedPlatform)
        ? selectedPlatform
        : selectedPlatform
          ? [selectedPlatform]
          : [],
      owner: Array.isArray(selectedOwner)
        ? selectedOwner
        : selectedOwner
          ? [selectedOwner]
          : [],
      tags: Array.isArray(selectedTags)
        ? selectedTags
        : selectedTags
          ? [selectedTags]
          : [],
      time: timeFilter || null,
      startDate: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
      endDate: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null,
      followupdate: followuptimeFilter || null,
      followupstartDate: followupstartDate
        ? dayjs(followupstartDate).format("YYYY-MM-DD")
        : null,
      followupendDate: followupendDate
        ? dayjs(followupendDate).format("YYYY-MM-DD")
        : null,
      isActive: true,
      isDeleted: false,
    };

    try {
      // send payload to backend
      const response = await addFilter(payload);

      // build slug (unique identifier for query params)
      const slug = fav.name.toLowerCase().replace(/\s+/g, "-");

      // build saved filter
      const savedFilter = {
        ...payload,
        _id: response.data?._id,
        slug,
      };

      // save in local storage / state
      // filters.push(savedFilter);
      const updatedFilters = [...filters, savedFilter];
      saveFavouriteFilters(updatedFilters);
      setFavouriteFilters(updatedFilters);

      message.success("Favourite filter saved!");
    } catch (error) {
      console.error("Failed to save filter:", error);
      message.error("Failed to save favourite filter!");
    }
  };

  const editFavouriteFilter = (record: any) => {
    setEditingFilterId(record._id);
    setFavName(record.name || "");
    setSelectedIcon(record.icon || "");
    setSelectedSource(record.source?.length ? record.source : []);
    setSelectedPlatform(record.sourceid?.length ? record.sourceid : null);
    setSelectedPriority(record.priority?.length ? record.priority[0] : null);
    setSelectedCountry(record.country?.length ? record.country[0] : null);
    setSelectedStatus(record.status?.length ? record.status : []);
    setSelectedTags(record.tags?.length ? record.tags : []);
    setSelectedOwner(record.owner?.length ? record.owner : []);
    if (record.time) {
      setTimeFilter(record.time);
      if (record.time === "custom" && record.startDate && record.endDate) {
        setStartDate(dayjs(record.startDate));
        setEndDate(dayjs(record.endDate));
      }
    } else {
      setTimeFilter(undefined);
      setStartDate(null);
      setEndDate(null);
    }
    if (record.followupdate) {
      setfollowupTimeFilter(record.followupdate as any);
      if (record.followupdate === "followupCustom" && record.followupdatestartDate && record.followupdateendDate) {
        setfollowupStartDate(dayjs(record.followupstartDate));
        setfollowupEndDate(dayjs(record.followupdateendDate));
      }
    } else {
      setfollowupTimeFilter(undefined);
      setfollowupStartDate(null);
      setfollowupEndDate(null);
    }
  };

  const cancelEditFilter = () => {
    setEditingFilterId(null);
    setFavName("");
    setSelectedIcon("");
    setInlineEditOpen(false);
    resetCrmSettings();
  };

  // Click edit on a top tab -> expand the filter form inline below the tabs (no popup)
  const openFilterForEdit = (record: any, leftOffset?: number) => {
    // ponytail: preserve in-progress edits when reopening the same filter tab
    if (editingFilterId !== record._id) editFavouriteFilter(record);
    setInlineCollapsed(false);
    if (typeof leftOffset === "number") setInlineAnchorLeft(leftOffset);
    setInlineEditOpen(true);
    setLeadAnalyticsModal(false);
  };

  const updateFavouriteFilter = async () => {
    if (!favName.trim()) {
      setError("Please enter favorite name!");
      return;
    }
    if (!editingFilterId) return;
    setError("");
    const payload = {
      type: "Analytics",
      userId: userId || null,
      icon: selectedIcon || "",
      name: favName,
      source: Array.isArray(selectedSource) ? selectedSource : selectedSource ? [selectedSource] : [],
      priority: Array.isArray(selectedPriority) ? selectedPriority : selectedPriority ? [selectedPriority] : [],
      country: Array.isArray(selectedCountry) ? selectedCountry : selectedCountry ? [selectedCountry] : [],
      status: Array.isArray(selectedStatus) ? selectedStatus : selectedStatus ? [selectedStatus] : [],
      sourceid: Array.isArray(selectedPlatform) ? selectedPlatform : selectedPlatform ? [selectedPlatform] : [],
      owner: Array.isArray(selectedOwner) ? selectedOwner : selectedOwner ? [selectedOwner] : [],
      tags: Array.isArray(selectedTags) ? selectedTags : selectedTags ? [selectedTags] : [],
      time: timeFilter || null,
      startDate: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
      endDate: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null,
      followupdate: followuptimeFilter || null,
      followupstartDate: followupstartDate ? dayjs(followupstartDate).format("YYYY-MM-DD") : null,
      followupendDate: followupendDate ? dayjs(followupendDate).format("YYYY-MM-DD") : null,
      isActive: true,
      isDeleted: false,
    };
    try {
      await updateFilter(editingFilterId, payload);
      const updatedFilters = favouriteFilters.map((f: any) =>
        f._id === editingFilterId ? { ...f, ...payload } : f,
      );
      saveFavouriteFilters(updatedFilters);
      setFavouriteFilters(updatedFilters);
      setEditingFilterId(null);
      setFavName("");
      setSelectedIcon("");
      setInlineEditOpen(false);
      message.success("Filter updated!");
    } catch (error) {
      console.error("Failed to update filter:", error);
      message.error("Failed to update filter!");
    }
  };

  const runFilterPreview = () => {
    const params = {
      source: Array.isArray(selectedSource) ? selectedSource : selectedSource ? [selectedSource] : [],
      sourceid: Array.isArray(selectedPlatform) ? selectedPlatform : selectedPlatform ? [selectedPlatform] : [],
      priority: Array.isArray(selectedPriority) ? selectedPriority : selectedPriority ? [selectedPriority] : [],
      country: Array.isArray(selectedCountry) ? selectedCountry : selectedCountry ? [selectedCountry] : [],
      status: Array.isArray(selectedStatus) ? selectedStatus : selectedStatus ? [selectedStatus] : [],
      owner: Array.isArray(selectedOwner) ? selectedOwner : selectedOwner ? [selectedOwner] : [],
      tags: Array.isArray(selectedTags) ? selectedTags : selectedTags ? [selectedTags] : [],
      timeFilter: timeFilter || null,
      startDate: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
      endDate: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null,
      followupdate: followuptimeFilter || null,
      followupstartDate: followupstartDate ? dayjs(followupstartDate).format("YYYY-MM-DD") : null,
      followupendDate: followupendDate ? dayjs(followupendDate).format("YYYY-MM-DD") : null,
      page: 1,
    };
    setLeadAnalyticsModal(false);
    setInlineEditOpen(false);
    fetchLeadsSource(params);
    message.success("Preview applied — review the results before saving.");
  };

  const saveFavouriteFilters = (filters: any[]) => {
    try {
      // ✅ only save Analytics type filters
      const onlyAnalytics = filters.filter((f: any) => f.type === "Analytics");
      localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(onlyAnalytics));
    } catch (error) {
      console.error("Failed to save favourite filters to localStorage", error);
    }
  };

  const CrmSettingsMenu = (
    <div
      style={{
        display: "flex",
        maxWidth: inlineEditOpen ? "none" : "750px",
        background: "linear-gradient(145deg, #ffffff, #f8fafc)",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        borderRadius: "12px",
        overflow: inlineEditOpen ? "visible" : "hidden",
        padding: "16px",
        gap: "20px",
        height: inlineEditOpen ? "auto" : "85vh",
      }}
    >
      {/* -------- Favorites Section -------- */}
      <div
        style={{
          flex: 1,
          padding: 16,
          border: "1px solid #EAECEF",
          borderRadius: 14,
          background: "#fff",
          overflowY: inlineEditOpen ? "visible" : "auto",
          maxHeight: inlineEditOpen ? "none" : "calc(85vh - 40px)",
          display: inlineEditOpen ? "none" : "flex",
          flexDirection: "column",
        }}
      >
        <div className="flex items-center justify-between" style={{ marginBottom: 14 }}>
          <h4 style={{ fontSize: 15, fontWeight: 700, color: "#111827", margin: 0 }}>Saved Filters</h4>
          <span style={{ fontSize: 12, fontWeight: 600, color: "#6B7280", background: "#F8FAFC", border: "1px solid #E5E7EB", borderRadius: 8, padding: "3px 10px" }}>{favouriteFilters.length}</span>
        </div>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps} style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {favouriteFilters.map((record: any, index: number) => {
                  const IconComp = (Icons as any)[record.icon];
                  const isCopied = copiedId === record._id;
                  const isActive = selectedFav === record._id;
                  return (
                    <Draggable draggableId={record._id} index={index} key={record._id}>
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          onClick={() => applyFavouriteFilter(record)}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                            padding: "10px 12px",
                            borderRadius: 10,
                            border: `1px solid ${isActive ? "#1e3a8a" : "#EEF2F7"}`,
                            background: isActive ? "#F1F5FF" : "#fff",
                            cursor: "grab",
                            transition: "box-shadow 150ms ease, border-color 150ms ease",
                            ...provided.draggableProps.style,
                          }}
                          onMouseEnter={(e) => { if (!isActive) e.currentTarget.style.boxShadow = "0 2px 8px rgba(16,24,40,0.06)"; }}
                          onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "none"; }}
                        >
                          <Icons.HolderOutlined style={{ color: "#9CA3AF", fontSize: 14, flexShrink: 0 }} />
                          {IconComp && <IconComp style={{ fontSize: 16, color: "#1e3a8a", flexShrink: 0 }} />}
                          <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: 13, fontWeight: 600, color: "#111827" }}>{record.name}</span>
                          <div className="flex items-center" style={{ gap: 10, flexShrink: 0 }}>
                            <Tooltip title="Edit">
                              <Icons.EditOutlined
                                onClick={(e) => { e.stopPropagation(); editFavouriteFilter(record); }}
                                style={{ color: "#6366f1", cursor: "pointer", fontSize: 14 }}
                              />
                            </Tooltip>
                            <Tooltip title="Delete">
                              <Icons.DeleteOutlined
                                onClick={(e) => { e.stopPropagation(); deleteFavouriteFilter(record._id); }}
                                style={{ color: "#ef4444", cursor: "pointer", fontSize: 14 }}
                              />
                            </Tooltip>
                            <Tooltip title={isCopied ? "Copied" : "Copy"}>
                              {isCopied ? (
                                <RiCheckLine size={14} style={{ color: "#1890ff", cursor: "default" }} />
                              ) : (
                                <RiFileCopyLine
                                  size={14}
                                  className="fav-copy-btn copy-icon"
                                  style={{ cursor: "pointer", color: "#6b7280" }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedSource(record.source?.length ? record.source : null);
                                    setSelectedPlatform(record.sourceid?.length ? record.sourceid : null);
                                    setSelectedPriority(record.priority?.length ? record.priority[0] : null);
                                    setSelectedCountry(record.country?.length ? record.country[0] : null);
                                    setSelectedStatus(record.status?.length ? record.status : null);
                                    setSelectedTags(record.tags?.length ? record.tags : null);
                                    setSelectedOwner(record.owner?.length ? record.owner : null);
                                    if (record.time) {
                                      setTimeFilter(record.time);
                                      if (record.time === "custom" && record.startDate && record.endDate) {
                                        setStartDate(dayjs(record.startDate));
                                        setEndDate(dayjs(record.endDate));
                                      }
                                    } else {
                                      setTimeFilter(undefined);
                                      setStartDate(null);
                                      setEndDate(null);
                                    }
                                    if (record.followupdate) {
                                      setfollowupTimeFilter(record.followupdate as any);
                                      if (record.followupdate === "followupCustom" && record.startDate && record.endDate) {
                                        setfollowupStartDate(dayjs(record.followupstartDate));
                                        setfollowupEndDate(dayjs(record.followupdateendDate));
                                      }
                                    } else {
                                      setfollowupTimeFilter(undefined);
                                      setfollowupStartDate(null);
                                      setfollowupEndDate(null);
                                    }
                                    setCopiedId(record._id);
                                    setTimeout(() => setCopiedId(null), 2000);
                                  }}
                                />
                              )}
                            </Tooltip>
                          </div>
                        </div>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>

      {/* -------- Filters Section -------- */}
      <div
        style={{
          padding: "12px",
          border: "1px solid #e5e7eb",
          borderRadius: "8px",
          background: "#fff",
          overflowY: inlineEditOpen ? "visible" : "auto",
          maxHeight: inlineEditOpen ? "none" : "calc(85vh - 40px)",
          flex: 1,
        }}
      >

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", alignItems: "start" }}>
          <div style={{ display: "flex", gap: "8px", gridColumn: "1 / -1" }}>
            {/* --- Name Input --- */}
            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <Input
                placeholder="Enter favorite name"
                className="la-fav-name"
                value={favName}
                onChange={(e) => setFavName(e.target.value)}
                style={{
                  width: "100%",
                  height: 40,
                  padding: "0 14px",
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#111827",
                  background: "#FFFFFF",
                  border: "1px solid #D9D9D9",
                  borderRadius: 8,
                  display: "flex",
                  alignItems: "center",
                  transition: "border-color 200ms ease, box-shadow 200ms ease",
                }}
              />
              {error && (
                <span
                  style={{ color: "#EF4444", fontSize: 12, marginTop: 6 }}
                >
                  {getErrorMessage(error)}
                </span>
              )}
            </div>
            {/* --- Save Button --- */}
          </div>

          <Select
            placeholder="Select Source"
            mode="multiple"
            showSearch
            allowClear
            value={selectedSource}
            onChange={(val) => setSelectedSource(val)}
            optionFilterProp="label"
            filterOption={(input, option) =>
              typeof option?.label === "string" &&
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            options={sources.map((item: any) => ({
              value: item._id,
              label: item.name, // plain string (searchable)
              color: item.color, // metadata
            }))}
            optionRender={(option) => (
              <span style={{ color: option.data.color }}>
                {option.data.label}
              </span>
            )}
            style={{ width: "100%" }}
            maxTagCount="responsive"
          />

          <Select
            placeholder="Select Source Platform Name"
            showSearch
            mode="multiple"
            onClick={(e) => e.stopPropagation()}
            allowClear
            value={selectedPlatform} // bind state
            style={{ width: "100%" }}
            maxTagCount="responsive"
            onChange={(val) => setSelectedPlatform(val)} // update state
            optionFilterProp="children" // 👈 this makes search work on the option text
            filterOption={(input, option) =>
              (option?.children as unknown as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {platform.map((pla: any) => (
              <Select.Option key={pla._id} value={pla._id}>
                {pla.username}
              </Select.Option>
            ))}
          </Select>

          <Select
            placeholder="Select Priority"
            showSearch
            allowClear
            value={selectedPriority}
            onChange={(val) => setSelectedPriority(val)}
            optionFilterProp="label"
            filterOption={(input, option) =>
              typeof option?.label === "string" &&
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            options={[
              { value: "High", label: "High", color: priorityColors.High },
              {
                value: "Medium",
                label: "Medium",
                color: priorityColors.Medium,
              },
              { value: "Low", label: "Low", color: priorityColors.Low },
            ]}
            optionRender={(option) => (
              <span style={{ color: option.data.color }}>
                {option.data.label}
              </span>
            )}
          />

          <Select
            size="large"
            bordered={false}
            placeholder="Select Country"
            // className="Allinput"
            allowClear
            showSearch
            optionFilterProp="children"
            onClick={(e) => e.stopPropagation()}
            value={selectedCountry} // bind state
            onChange={(val: any) => setSelectedCountry(val)} // update state
          >
            {countries.map((c) => (
              <Select.Option key={c.code} value={c.name}>
                {c.name}
              </Select.Option>
            ))}
          </Select>

          <Select
            style={{ width: "100%", height: "33px" }}
            value={timeFilter}
            onChange={(value, option) => {
              setTimeFilter(value);
              setPage(1);

              if (value === "custom") {
                if (
                  option &&
                  !Array.isArray(option) &&
                  (option as { startDate?: string; endDate?: string })
                    .startDate &&
                  (option as { startDate?: string; endDate?: string }).endDate
                ) {
                  // directly set range from option
                  setStartDate(
                    dayjs((option as { startDate: string }).startDate),
                  );
                  setEndDate(dayjs((option as { endDate: string }).endDate));
                } else {
                  // show picker if not yet selected
                  setShowRangePicker(true);
                }
              } else {
                setStartDate(null);
                setEndDate(null);
                setTempStartDate(null);
                setTempEndDate(null);
                setShowRangePicker(false);
              }
            }}
            placeholder="Select Time Filter"
            allowClear
            options={timeFilterOptions}
            optionLabelProp="label"
            dropdownRender={(menu) => (
              <div>
                {menu}
                <div style={{ textAlign: "center" }}>
                  <Button
                    type="link"
                    style={{ color: "red" }}
                    onClick={() => {
                      setTimeFilter(undefined);
                      setStartDate(null);
                      setEndDate(null);
                      setTempStartDate(null);
                      setTempEndDate(null);
                      setShowRangePicker(false);
                    }}
                  >
                    Clear All Filters
                  </Button>
                </div>
              </div>
            )}
          />
          {showRangePicker && (
            <div
              style={{
                position: "fixed",
                top: "25%",
                left: "70%",
                transform: "translate(-50%, -50%)",
                zIndex: 1500,
                background: "#fff",
                padding: "16px",
                boxShadow:
                  "0 3px 6px -4px rgba(0,0,0,0.12), 0 6px 16px 0 rgba(0,0,0,0.08), 0 9px 28px 8px rgba(0,0,0,0.05)",
                borderRadius: "8px",
                width: "fit-content",
              }}
            >
              <DatePicker.RangePicker
                value={
                  tempStartDate && tempEndDate
                    ? [tempStartDate, tempEndDate]
                    : null
                }
                onChange={(dates) => {
                  setTempStartDate(dates ? dates[0] : null);
                  setTempEndDate(dates ? dates[1] : null);
                }}
                format="YYYY-MM-DD"
                style={{ marginBottom: "16px", width: "100%" }}
                allowClear={false}
                getPopupContainer={(triggerNode) => document.body}
                popupStyle={{ zIndex: 2000 }} // make sure it’s above your box
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "8px",
                }}
              >
                <Button
                  onClick={() => {
                    setShowRangePicker(false);
                    setTempStartDate(null);
                    setTempEndDate(null);
                    setTimeFilter(undefined);
                    setStartDate(null);
                    setEndDate(null);
                    setPage(1);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  className="allbuttons text-white deal-apply"
                  onClick={() => {
                    if (tempStartDate && tempEndDate) {
                      setStartDate(tempStartDate);
                      setEndDate(tempEndDate);
                      setShowRangePicker(false);
                      setPage(1);
                      setTimeFilter("custom");
                    }
                  }}
                >
                  Apply
                </Button>
              </div>
            </div>
          )}

          <Select
            placeholder="Select Status"
            showSearch
            allowClear
            mode="multiple"
            value={selectedStatus} // bind state
            onChange={(val) => setSelectedStatus(val)} // update state
            optionFilterProp="label"
            filterOption={(input: any, option) =>
              (option?.label as any).toLowerCase().includes(input)
            }
            options={statuses.map((item: any) => ({
              value: item._id,
              label: item.name, // plain string (searchable)
              color: item.color, // metadata
            }))}
            optionRender={(option) => (
              <span style={{ color: option.data.color }}>
                {option.data.label}
              </span>
            )}
            style={{ width: "100%" }}
            maxTagCount="responsive"
          />

          <Select
            placeholder="Select Tags"
            showSearch
            mode="multiple"
            style={{ width: "100%" }}
            maxTagCount="responsive"
            value={selectedTags}
            onChange={(val) => setSelectedTags(val)}
            allowClear
            optionFilterProp="label"
            filterOption={(input, option) =>
              typeof option?.label === "string" &&
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            options={tags.map((tag: any) => ({
              value: tag._id,
              label: tag.name, // ✅ plain string for search
              color: tag.color, // extra metadata
            }))}
            optionRender={(option) => (
              <span style={{ color: option.data.color }}>
                {option.data.label}
              </span>
            )}
          />

          <Select
            style={{ width: "100%", height: "33px" }}
            value={followuptimeFilter}
            onChange={(value, option) => {
              setfollowupTimeFilter(value);
              setPage(1);

              if (value === "followupCustom") {
                if (
                  option &&
                  !Array.isArray(option) &&
                  (
                    option as {
                      followupstartDate?: string;
                      followupendDate?: string;
                    }
                  ).followupstartDate &&
                  (
                    option as {
                      followupstartDate?: string;
                      followupendDate?: string;
                    }
                  ).followupendDate
                ) {
                  // directly set range from option
                  setfollowupStartDate(
                    dayjs(
                      (option as { followupstartDate: string })
                        .followupstartDate,
                    ),
                  );
                  setfollowupEndDate(
                    dayjs(
                      (option as { followupendDate: string }).followupendDate,
                    ),
                  );
                } else {
                  // show picker if not yet selected
                  setfollowupShowRangePicker(true);
                }
              } else {
                setfollowupStartDate(null);
                setfollowupEndDate(null);
                setfollowupTempStartDate(null);
                setfollowupTempEndDate(null);
                setfollowupShowRangePicker(false);
              }
            }}
            placeholder="Select Follow Up Date"
            allowClear
            options={followupFilterOptions}
            optionLabelProp="label"
            dropdownRender={(menu) => (
              <div>
                {menu}
                <div style={{ textAlign: "center" }}>
                  <Button
                    type="link"
                    style={{ color: "red" }}
                    onClick={() => {
                      setfollowupTimeFilter(undefined);
                      setfollowupStartDate(null);
                      setfollowupEndDate(null);
                      setfollowupTempStartDate(null);
                      setfollowupTempEndDate(null);
                      setShowRangePicker(false);
                    }}
                  >
                    Clear All Filters
                  </Button>
                </div>
              </div>
            )}
          />
          {followupshowRangePicker && (
            <div
              style={{
                gridColumn: "1 / -1",
                position: "fixed",
                top: "25%",
                left: "70%",
                transform: "translate(-50%, -50%)",
                zIndex: 1500,
                background: "#fff",
                padding: "16px",
                boxShadow:
                  "0 3px 6px -4px rgba(0,0,0,0.12), 0 6px 16px 0 rgba(0,0,0,0.08), 0 9px 28px 8px rgba(0,0,0,0.05)",
                borderRadius: "8px",
                width: "fit-content",
              }}
            >
              <DatePicker.RangePicker
                value={
                  followuptempStartDate && followuptempEndDate
                    ? [followuptempStartDate, followuptempEndDate]
                    : null
                }
                onChange={(dates) => {
                  setfollowupTempStartDate(dates ? dates[0] : null);
                  setfollowupTempEndDate(dates ? dates[1] : null);
                }}
                format="YYYY-MM-DD"
                style={{ marginBottom: "16px", width: "100%" }}
                allowClear={false}
                getPopupContainer={(triggerNode) => document.body}
                popupStyle={{ zIndex: 2000 }} // make sure it’s above your box
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "8px",
                }}
              >
                <Button
                  onClick={() => {
                    setfollowupShowRangePicker(false);
                    setfollowupTempStartDate(null);
                    setfollowupTempEndDate(null);
                    setfollowupTimeFilter(undefined);
                    setfollowupStartDate(null);
                    setfollowupEndDate(null);
                    setPage(1);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  className="allbuttons text-white deal-apply"
                  onClick={() => {
                    if (followuptempStartDate && followuptempEndDate) {
                      setfollowupStartDate(followuptempStartDate);
                      setfollowupEndDate(followuptempEndDate);
                      setfollowupShowRangePicker(false);
                      setPage(1);
                      setfollowupTimeFilter("followupCustom");
                    }
                  }}
                >
                  Apply
                </Button>
              </div>
            </div>
          )}
          {isAdmin && (
            <Select
              placeholder="Select Owner Name"
              showSearch
              mode="multiple"
              onClick={(e) => e.stopPropagation()}
              allowClear
              style={{ width: "100%" }}
              maxTagCount="responsive"
              value={selectedOwner} // bind state
              onChange={(val) => setSelectedOwner(val)} // update state
              optionFilterProp="children" // 👈 this makes search work on the option text
              filterOption={(input, option) =>
                (option?.children as unknown as string)
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            >
              {developers.map((dev: any) => (
                <Select.Option key={dev._id} value={dev._id}>
                  {dev.username}
                </Select.Option>
              ))}
            </Select>
          )}
          <div className="flex justify-end" style={{ gap: "8px", gridColumn: "1 / -1", marginTop: 8, paddingTop: 12, borderTop: "1px solid #EEF2F7", position: "sticky", bottom: 0, background: "#fff" }}>
            <button
              className="flex items-center justify-center"
              style={{
                width: "70px",
                height: "30px",
                borderRadius: "6px",
                border: "1px solid #d1d5db",
                background: "#fff",
                color: "#374151",
                fontWeight: 600,
                fontSize: 13,
                cursor: "pointer",
              }}
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                runFilterPreview();
              }}
            >
              Run
            </button>
            {editingFilterId ? (
              <>
                <button
                  className="flex items-center justify-center"
                  style={{
                    width: "64px",
                    height: "30px",
                    borderRadius: "6px",
                    border: "1px solid #d1d5db",
                    background: "#fff",
                    color: "#374151",
                    fontWeight: 600,
                    fontSize: 13,
                    cursor: "pointer",
                  }}
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    cancelEditFilter();
                  }}
                >
                  Cancel
                </button>
                <button
                  className="flex items-center justify-center"
                  style={{
                    width: "104px",
                    height: "30px",
                    borderRadius: "6px",
                    border: "1px solid #d1d5db",
                    background: "#fff",
                    color: "#374151",
                    fontWeight: 600,
                    fontSize: 13,
                    cursor: "pointer",
                  }}
                  type="submit"
                  onClick={(e) => {
                    e.stopPropagation();
                    setEditingFilterId(null);
                    addFavouriteFilter({ name: favName, icon: selectedIcon });
                    setFavName("");
                    setSelectedIcon("");
                  }}
                >
                  Save as New
                </button>
                <button
                  className="allsubmitebutton flex items-center justify-center"
                  style={{ width: "70px", height: "30px", borderRadius: "6px" }}
                  type="submit"
                  onClick={(e) => {
                    e.stopPropagation();
                    updateFavouriteFilter();
                  }}
                >
                  Update
                </button>
              </>
            ) : (
              <button
                className="allsubmitebutton flex items-center justify-center"
                style={{ width: "53px", height: "30px", borderRadius: "6px" }}
                type="submit"
                onClick={(e) => {
                  e.stopPropagation();
                  addFavouriteFilter({ name: favName, icon: selectedIcon });
                  setFavName("");
                  setSelectedIcon("");
                }}
              >
                Save
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  {
    /* <Dropdown
                                overlay={FilterMenu}
                                trigger={["click"]}
                                open={filterDropdownOpen}
                                onOpenChange={(open) => setFilterDropdownOpen(open)}
                            >
                                <Button
                                    icon={<FilterOutlined />}
                                    style={{
                                        height: "40px",
                                        padding: "0 18px",
                                        borderRadius: "28px",
                                        fontWeight: 700,
                                        fontSize: "15px",
                                        background: "linear-gradient(135deg, #001529, #1e3a8a)",
                                        color: "#ffffff",
                                        boxShadow: "0 4px 12px rgba(30, 58, 138, 0.45)",
                                        border: "none",
                                        letterSpacing: "0.5px",
                                        transition: "all 0.25s ease-in-out",
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "scale(1.07)";
                                        e.currentTarget.style.boxShadow = "0 6px 16px rgba(30, 58, 138, 0.6)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "scale(1)";
                                        e.currentTarget.style.boxShadow = "0 4px 12px rgba(30, 58, 138, 0.45)";
                                    }}
                                >
                                    Filters
                                </Button>
                            </Dropdown> */
  }
  const resetCrmSettings = () => {
    setSelectedSource([]);
    setSelectedPlatform(null);
    setSelectedPriority(null);
    setSelectedCountry(null);
    setTimeFilter(undefined);
    setStartDate(null);
    setEndDate(null);
    setTempStartDate(null);
    setShowRangePicker(false);

    setSelectedStatus([]);
    setSelectedTags([]);
    setfollowupTimeFilter(undefined);
    setfollowupStartDate(null);
    setfollowupEndDate(null);
    setfollowupTempStartDate(null);
    setfollowupTempEndDate(null);
    setfollowupShowRangePicker(false);

    setSelectedOwner([]);
    setFavName("");
    setError("");
    setEditingFilterId(null);
  };

  const sizeStyles: any = {
    small: {
      padding: "4px 0",
      fontSize: "14px",
    },
    middle: {
      padding: "8px 0",
      fontSize: "16px",
    },
    large: {
      padding: "12px 0",
      fontSize: "18px",
    },
  };

  const updateArrows = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth);
  };

  useEffect(() => {
    updateArrows();
    const el = scrollRef.current;
    if (!el) return;
    el.addEventListener("scroll", updateArrows);
    window.addEventListener("resize", updateArrows);
    return () => {
      el.removeEventListener("scroll", updateArrows);
      window.removeEventListener("resize", updateArrows);
    };
  }, []);

  const scroll = (direction: "left" | "right") => {
    const el = scrollRef.current;
    if (!el) return;
    const scrollAmount = 180; // width of one tab
    el.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  const pipelineData = useMemo(() => {
    const dataPoints: Array<{ key: string; label: string; value: number }> = [];

    let months: Array<{ monthIndex: number; label: string }> = [];
    if (pipelineTimeframe === "jan-apr") {
      months = [
        { monthIndex: 0, label: "January" },
        { monthIndex: 1, label: "February" },
        { monthIndex: 2, label: "March" },
        { monthIndex: 3, label: "April" },
      ];
    } else if (pipelineTimeframe === "may-aug") {
      months = [
        { monthIndex: 4, label: "May" },
        { monthIndex: 5, label: "June" },
        { monthIndex: 6, label: "July" },
        { monthIndex: 7, label: "August" },
      ];
    } else if (pipelineTimeframe === "sep-dec") {
      months = [
        { monthIndex: 8, label: "September" },
        { monthIndex: 9, label: "October" },
        { monthIndex: 10, label: "November" },
        { monthIndex: 11, label: "December" },
      ];
    } else {
      months = [
        { monthIndex: 4, label: "May" },
        { monthIndex: 5, label: "June" },
        { monthIndex: 6, label: "July" },
        { monthIndex: 7, label: "August" },
      ];
    }

    months.forEach(({ monthIndex, label }) => {
      dataPoints.push({
        key: String(monthIndex),
        label,
        value: 0,
      });
    });

    let hasData = false;
    allLeads.forEach((lead: any) => {
      const val = Number(lead.leadValue || 0);
      const dateStr = lead.createdAt;
      if (dateStr) {
        const dateObj = dayjs(dateStr);
        const monthIndex = dateObj.month();
        const key = String(monthIndex);

        const found = dataPoints.find((dp) => dp.key === key);
        if (found) {
          found.value += val;
          hasData = true;
        }
      }
    });

    if (!hasData) {
      const dbHasAnyLeads = allLeads.length > 0;
      if (!dbHasAnyLeads) {
        let mockupValues: number[] = [];
        if (pipelineTimeframe === "jan-apr") {
          mockupValues = [1450000, 1620000, 1850000, 1950000];
        } else if (pipelineTimeframe === "may-aug") {
          mockupValues = [2050000, 2250000, 2180000, 2450000];
        } else {
          mockupValues = [2350000, 2550000, 2700000, 2950000];
        }
        dataPoints.forEach((dp, idx) => {
          dp.value = mockupValues[idx] || 0;
        });
      }
    }

    return dataPoints;
  }, [allLeads, pipelineTimeframe]);

  const pipelineChartOptions = useMemo(() => {
    return {
      grid: {
        left: "3%",
        right: "3%",
        top: "15%",
        bottom: "5%",
        containLabel: true,
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
          shadowStyle: { color: "rgba(0, 114, 255, 0.06)" },
        },
        backgroundColor: "rgba(15, 23, 42, 0.92)",
        borderWidth: 0,
        padding: [8, 12],
        textStyle: { color: "#fff", fontSize: 12 },
        formatter: (params: any) => {
          const val = params[0].value;
          return `<span style="opacity:0.7">${params[0].name}</span><br/><b style="font-size:14px">₹${val.toLocaleString("en-IN")}</b>`;
        },
      },
      xAxis: {
        type: "category",
        data: pipelineData.map((d) => d.label),
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: {
          color: "#9ca3af",
          fontSize: 11,
        },
      },
      yAxis: {
        type: "value",
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: {
          lineStyle: {
            color: "#f3f4f6",
          },
        },
        axisLabel: {
          color: "#9ca3af",
          fontSize: 11,
          formatter: (val: number) => {
            if (val === 0) return "₹0";
            if (val >= 10000000) return `₹${(val / 10000000).toFixed(0)}Cr`;
            if (val >= 100000) return `₹${(val / 100000).toFixed(0)}L`;
            if (val >= 1000) return `₹${(val / 1000).toFixed(0)}K`;
            return `₹${val}`;
          },
        },
      },
      series: [
        {
          type: "bar",
          data: pipelineData.map((d) => d.value),
          barWidth: "45%",
          showBackground: true,
          backgroundStyle: {
            color: "rgba(0, 114, 255, 0.05)",
            borderRadius: [6, 6, 0, 0],
          },
          itemStyle: {
            borderRadius: [6, 6, 0, 0],
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: "#00c6ff" },
                { offset: 1, color: "#0072ff" },
              ],
            },
          },
          emphasis: {
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: "#38e0ff" },
                  { offset: 1, color: "#0059ff" },
                ],
              },
            },
          },
          label: {
            show: true,
            position: "top",
            formatter: (params: any) => {
              const val = params.value;
              if (val >= 10000000) return `₹${(val / 10000000).toFixed(2)}Cr`;
              if (val >= 100000) return `₹${(val / 100000).toFixed(2)}L`;
              return `₹${val.toLocaleString("en-IN")}`;
            },
            color: "#1f2937",
            fontWeight: "bold",
            fontSize: 10,
          },
        },
      ],
    };
  }, [pipelineData]);

  const formatLegendValue = (val: number) => {
    if (val >= 10000000) return `₹${(val / 10000000).toFixed(1)}Cr`;
    if (val >= 100000) return `₹${(val / 100000).toFixed(1)}L`;
    if (val >= 1000) return `₹${(val / 1000).toFixed(0)}K`;
    return `₹${val}`;
  };

  const donutChartOptions = useMemo(() => {
    const displaySources = metrics;

    const totalVal = displaySources.reduce(
      (sum, m) => sum + (m.leadValue || 0),
      0,
    );
    const hasData = displaySources.some((d) => d.leadValue > 0);

    const chartData = displaySources.map((item, idx) => ({
      name: item.title,
      value: item.leadValue || 0,
      itemStyle: {
        color: item.color || "#1890ff",
        borderColor: "#fff",
        borderWidth: 2,
      },
    }));

    const seriesData = hasData
      ? chartData
      : [
          {
            name: "No Data",
            value: 1,
            itemStyle: {
              color: "#f3f4f6",
              borderColor: "#fff",
              borderWidth: 2,
            },
          },
        ];

    // Format center total value
    const formatCenterValue = (val: number) => {
      if (val >= 10000000) return `₹${(val / 10000000).toFixed(2)}Cr`;
      if (val >= 100000) return `₹${(val / 100000).toFixed(2)}L`;
      if (val >= 1000) return `₹${(val / 1000).toFixed(1)}K`;
      return `₹${val}`;
    };

    return {
      title: {
        text: formatCenterValue(totalVal),
        subtext: "Total",
        left: "center",
        top: "38%",
        itemGap: 4,
        textStyle: {
          fontSize: 22,
          fontWeight: "bold",
          color: "#0f172a",
          fontFamily: "Outfit, Inter, sans-serif",
        },
        subtextStyle: {
          fontSize: 12,
          color: "#64748b",
          fontFamily: "Outfit, Inter, sans-serif",
          fontWeight: "normal",
        },
      },
      tooltip: {
        trigger: "item",
        formatter: (params: any) => {
          if (params.name === "No Data") return "No Data";
          const val = params.value;
          return `${params.name}: ₹${val.toLocaleString("en-IN")} (${params.percent}%)`;
        },
      },
      series: [
        {
          name: "Leads by Source",
          type: "pie",
          radius: ["60%", "82%"],
          center: ["50%", "50%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
          },
          labelLine: {
            show: false,
          },
          data: seriesData,
        },
      ],
    };
  }, [metrics]);

  const donutLegendItems = useMemo(() => {
    const displaySources = metrics;

    const totalVal = displaySources.reduce(
      (sum, m) => sum + (m.leadValue || 0),
      0,
    );

    if (!displaySources.length) {
      return [{ name: "No Data", leadValue: 0, pct: 0, color: "#f3f4f6" }];
    }

    return displaySources.map((item, idx) => {
      const pct =
        totalVal > 0 ? Math.round((item.leadValue / totalVal) * 100) : 0;
      return {
        name: item.title,
        leadValue: item.leadValue || 0,
        pct,
        color: item.color || "#1890ff",
      };
    });
  }, [metrics]);

  const statusDonutChartOptions = useMemo(() => {
    const displayStatuses = leadsByStatus;
    
    const totalLeadsByStatus = displayStatuses.reduce(
      (sum, item) => sum + (item.leadCount || 0),
      0,
    );
    const hasData = displayStatuses.some((item) => item.leadCount > 0);

    const chartData = displayStatuses.map((item) => ({
      name: item.name,
      value: item.leadCount || 0,
      leadValue: item.leadValue || 0,
      itemStyle: {
        color: item.color || "#94a3b8",
        borderColor: "#fff",
        borderWidth: 2,
      },
    }));

    const seriesData = hasData
      ? chartData
      : [
          {
            name: "No Data",
            value: 1,
            leadValue: 0,
            itemStyle: {
              color: "#f3f4f6",
              borderColor: "#fff",
              borderWidth: 2,
            },
          },
        ];

    return {
      title: {
        text: totalLeadsByStatus.toLocaleString("en-IN"),
        subtext: "Leads",
        left: "center",
        top: "38%",
        itemGap: 4,
        textStyle: {
          fontSize: 22,
          fontWeight: "bold",
          color: "#0f172a",
          fontFamily: "Outfit, Inter, sans-serif",
        },
        subtextStyle: {
          fontSize: 12,
          color: "#64748b",
          fontFamily: "Outfit, Inter, sans-serif",
          fontWeight: "normal",
        },
      },
      tooltip: {
        trigger: "item",
        formatter: (params: any) => {
          if (params.name === "No Data") return "No Data";
          return `${params.name}: ${params.value.toLocaleString("en-IN")} leads (${params.percent}%)<br/>Value: ₹${params.data.leadValue?.toLocaleString("en-IN") || 0}`;
        },
      },
      series: [
        {
          name: "Leads by Status",
          type: "pie",
          radius: ["60%", "82%"],
          center: ["50%", "50%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
          },
          labelLine: {
            show: false,
          },
          data: seriesData,
        },
      ],
    };
  }, [leadsByStatus]);

  const statusLegendItems = useMemo(() => {
    const displayStatuses = leadsByStatus;
    const totalLeadsByStatus = displayStatuses.reduce(
      (sum, item) => sum + (item.leadCount || 0),
      0,
    );

    if (!displayStatuses.length) {
      return [{ name: "No Data", leadCount: 0, pct: 0, color: "#f3f4f6" }];
    }

    return displayStatuses.map((item) => ({
      name: item.name,
      leadCount: item.leadCount || 0,
      pct:
        totalLeadsByStatus > 0
          ? Math.round((item.leadCount / totalLeadsByStatus) * 100)
          : 0,
      color: item.color || "#94a3b8",
    }));
  }, [leadsByStatus]);

  const getBarContent = (metric: any, index: number) => {
    const isZero = (metric.leadValue || 0) === 0;
    if (isZero) {
      return {
        inside: "₹0",
        right: " (0)",
      };
    }
    if (index === 0) {
      return {
        inside: `₹${metric.leadValue?.toLocaleString("en-IN")}`,
        right: `(${metric.filteredLeads})`,
      };
    }
    return {
      inside: `₹${metric.leadValue?.toLocaleString("en-IN")}`,
      right: `(${metric.filteredLeads})`,
    };
  };

  const renderCard = (
    title: string,
    icon1: React.ReactNode,
    value1: React.ReactNode,
    icon2: React.ReactNode,
    value2: React.ReactNode,
    change?: {
      icon: React.ReactNode;
      text: string | number;
      color: string;
    },
  ) => {
    return (
      <div
        className="rounded-2xl p-4 text-white shadow-sm flex flex-col justify-between hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300"
        style={{
          background: "linear-gradient(135deg, #001529 0%, #1e3a8a 100%)",
          flex: "1 1 0px",
          minWidth: "0",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          minHeight: "96px",
        }}
      >
        {/* Title + Icon */}
        <div className="flex items-start justify-between mb-1">
          <span className="text-[10px] font-bold uppercase tracking-wider text-white/70 block overflow-hidden text-ellipsis whitespace-nowrap">
            {title}
          </span>
          <div className="w-7 h-7 rounded-lg bg-white/15 flex items-center justify-center flex-shrink-0">
            {icon1}
          </div>
        </div>

        {/* Primary Metric + Change */}
        <div className="flex items-end justify-between gap-2 mt-1">
          <span className="text-xl font-extrabold leading-none truncate">
            {value1}
          </span>
          {change && (
            <span
              className="text-xs font-bold flex items-center gap-0.5 flex-shrink-0"
              style={{ color: change.color }}
            >
              {change.icon}
              <span>{change.text}</span>
            </span>
          )}
        </div>

        {/* Secondary Metric */}
        <div className="flex items-center gap-1.5 mt-2 pt-2 border-t border-white/10">
          <div className="text-white/60 flex-shrink-0">{icon2}</div>
          <span className="text-white/80 text-xs font-semibold truncate">
            {value2}
          </span>
        </div>
      </div>
    );
  };

  // --- Indian currency formatter (Lakh/Crore) ---
const formatINR = (val: number) => {
  if (val >= 10000000) return `₹${(val / 10000000).toFixed(2)}Cr`;
  if (val >= 100000) return `₹${(val / 100000).toFixed(2)}L`;
  if (val >= 1000) return `₹${(val / 1000).toFixed(1)}K`;
  return `₹${val}`;
};

const formatINRFull = (val: number) => `₹${Number(val || 0).toLocaleString("en-IN")}`;

// Indian-numbering axis formatter for ECharts (never M/Million)
const axisINR = (val: number) => {
  if (val === 0) return "₹0";
  if (val >= 10000000) return `₹${(val / 10000000).toFixed(0)}Cr`;
  if (val >= 100000) return `₹${(val / 100000).toFixed(0)}L`;
  if (val >= 1000) return `₹${(val / 1000).toFixed(0)}K`;
  return `₹${val}`;
};

// Tiny sparkline option builder per source trend
const sparklineOption = (dates: string[], color: string) => {
  const buckets: Record<string, number> = {};
  (dates || []).forEach((d) => {
    const key = dayjs(d).format("YYYY-MM-DD");
    buckets[key] = (buckets[key] || 0) + 1;
  });
  const sorted = Object.keys(buckets).sort();
  const data = sorted.map((k) => buckets[k]);
  return {
    grid: { left: 0, right: 0, top: 2, bottom: 2 },
    xAxis: { type: "category", show: false, data: sorted },
    yAxis: { type: "value", show: false },
    series: [
      {
        type: "line",
        data: data.length ? data : [0, 0],
        smooth: true,
        symbol: "none",
        lineStyle: { width: 2, color },
        areaStyle: { color, opacity: 0.15 },
      },
    ],
  };
};

// KPI accent palette per source (cycled)
const KPI_ACCENTS = ["#EF4444", "#14B8A6", "#8B5CF6", "#F59E0B", "#22C55E", "#0EA5E9", "#EC4899"];
const KPI_ICON: Record<string, React.ReactNode> = {
  Upwork: <Icons.GlobalOutlined />,
  Guru: <Icons.StarOutlined />,
  Freelancer: <Icons.RocketOutlined />,
  Website: <Icons.CloudOutlined />,
  LinkedIn: <Icons.LinkOutlined />,
  Other: <Icons.AppstoreOutlined />,
};

const sparkDataFor = (title: string) => {
  const s = source.find((x: any) => x.sourceName === title);
  return s ? s.leadDates : [];
};

  return (
    <Spin spinning={loading} size="large">
    <div className="la-page-wrap" style={{ position: "relative" }}>
      <Row gutter={[12, 12]} align="middle">
        {/* Left side favourites */}
        <Col xs={20} sm={20} md={20} lg={20}>
          <div className="relative w-full flex items-center">
            {/* Left Arrow */}
            {canScrollLeft && (
              <div
                className="absolute left-0 top-0 z-10 flex items-center h-full px-1 bg-white"
                onClick={() => scroll("left")}
              >
                <Icons.LeftOutlined className="text-gray-500 text-lg cursor-pointer" />
              </div>
            )}

            {/* Scrollable Tabs */}
            <div
              ref={scrollRef}
              className="flex overflow-x-auto scrollbar w-full snap-x snap-mandatory rounded-lg border border-gray-200 bg-white"
              style={{ scrollBehavior: "smooth" }}
            >
              {favouriteFilters.map((f: any, index: number) => (
                <FilterTab
                  key={f._id}
                  f={f}
                  index={index}
                  totalTabs={favouriteFilters.length}
                  isActive={selectedFav === f._id}
                  defaultFilterId={defaultFilterId}
                  applyFavouriteFilter={applyFavouriteFilter}
                  setAsDefaultFilter={setAsDefaultFilter}
                  editFavouriteFilter={openFilterForEdit}
                />
              ))}
            </div>

            {/* Right Arrow */}
            {canScrollRight && (
              <div
                className="absolute right-0 top-0 z-10 flex items-center h-full px-1 bg-white"
                onClick={() => scroll("right")}
              >
                <Icons.RightOutlined className="text-gray-500 text-lg cursor-pointer" />
              </div>
            )}
          </div>
        </Col>

        {/* Right side filter button */}
        <Col xs={5} sm={5} md={4} lg={4}>
          <div className="flex justify-end">
            <Button
              icon={<FilterOutlined />}
              onClick={(e) => {
                e.stopPropagation();
                setLeadAnalyticsModal(true);
              }}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
                height: "40px",
                padding: "0 16px",
                minWidth: "90px",
                borderRadius: "28px",
                fontWeight: 700,
                fontSize: "15px",
                background: "linear-gradient(135deg, #001529, #1e3a8a)",
                color: "#ffffff",
                boxShadow: "0 4px 12px rgba(30, 58, 138, 0.45)",
                border: "none",
                letterSpacing: "0.5px",
                // transition: "all 0.25s ease-in-out",
              }}
            >
              Filters
            </Button>
            <Modal
              style={{
                bottom: 20,
                top: 20,
                // maxHeight: 'calc(100vh - 30px)',
                margin: "0 auto",
                position: "relative",
              }}
              styles={{
                body: {
                  overflowY: "auto",
                  fontFamily: "inter, sans-serif",
                },
                header: {
                  padding: "12px",
                  position: "sticky",
                  top: 0,
                  backgroundColor: "#f1f5ffff",
                },
                content: {
                  padding: 0,
                  overflow: "hidden",
                },
              }}
              title={
                <div
                  style={{
                    color: "#4b5563",
                    fontFamily: "inter, sans-serif",
                    fontSize: "20px",
                    fontWeight: 500,
                  }}
                >
                  Analytics Favourite Filter
                </div>
              }
              open={leadAnalyticsModal}
              onCancel={(e) => {
                (e.stopPropagation(), setLeadAnalyticsModal(false));
                resetCrmSettings();
              }}
              footer={null}
              width={650}
            >
              <div
                onClick={(e) => e.stopPropagation()}
                onMouseDown={(e) => e.stopPropagation()} // also block submenu toggling
              >
                {CrmSettingsMenu}
              </div>
            </Modal>
          </div>
        </Col>
      </Row>

      {/* ===== INLINE FILTER EXPAND (overlays cards, ~30% width, accordion header) ===== */}
      {inlineEditOpen && (
        <div
          className="la-inline-filter"
          style={{
            position: "absolute",
            left: inlineAnchorLeft,
            top: 52,
            zIndex: 50,
            width: "min(760px, 96%)",
            maxWidth: "calc(100% - 16px)",
            maxHeight: "calc(100vh - 70px)",
            overflowY: "auto",
            overflowX: "hidden",
            borderRadius: 14,
            border: "1px solid #EAECEF",
            background: "#fff",
            boxShadow: "0 12px 32px rgba(16,24,40,0.16)",
          }}
        >
          {/* Caret pointing up to the clicked tab */}
          <div
            style={{
              position: "absolute",
              top: -7,
              left: 20,
              width: 0,
              height: 0,
              borderLeft: "8px solid transparent",
              borderRight: "8px solid transparent",
              borderBottom: "8px solid #EAECEF",
            }}
          />
          <div
            style={{
              position: "absolute",
              top: -6,
              left: 21,
              width: 0,
              height: 0,
              borderLeft: "7px solid transparent",
              borderRight: "7px solid transparent",
              borderBottom: "7px solid #F8FAFC",
              zIndex: 1,
            }}
          />
          {/* Accordion header: shows which filter is being edited */}
          <div
            className="flex items-center justify-between"
            style={{
              padding: "12px 16px",
              borderBottom: "1px solid #F1F5F9",
              background: "#F8FAFC",
              cursor: "pointer",
              borderRadius: "14px 14px 0 0",
            }}
            onClick={() => setInlineCollapsed((v: boolean) => !v)}
          >
            <div className="flex items-center" style={{ gap: 8, minWidth: 0 }}>
              <Icons.DownOutlined style={{ fontSize: 12, color: "#6B7280", transition: "transform 200ms ease", transform: inlineCollapsed ? "rotate(-90deg)" : "none" }} />
              <span style={{ fontSize: 14, fontWeight: 700, color: "#111827", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {editingFilterId ? favName || "Edit Filter" : "Filter Builder"}
              </span>
            </div>
            <Icons.CloseOutlined
              style={{ cursor: "pointer", color: "#6B7280", fontSize: 16 }}
              onClick={(e) => { e.stopPropagation(); setInlineEditOpen(false); cancelEditFilter(); }}
            />
          </div>
          {/* Accordion body */}
          {!inlineCollapsed && (
            <div onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
              {CrmSettingsMenu}
            </div>
          )}
        </div>
      )}

      {/* ===== PREMIUM DASHBOARD BODY ===== */}
      <div style={{ marginTop: 20 }}>
        {/* ---------- KPI SECTION (hero spans 2 rows left, sources 2-row grid right) ---------- */}
        <div className="la-kpi-grid" style={{ marginBottom: 16, display: "grid", gridTemplateColumns: "minmax(240px, 1fr) 3fr", gap: 20 }}>
          {/* Hero: Total Lead Value — spans 2 rows */}
          {loading ? (
            <div style={{ padding: 24, borderRadius: 20, background: "#fff", border: "1px solid #EAECEF", minHeight: "100%", display: "flex", alignItems: "center" }}>
              <Skeleton active paragraph={{ rows: 4 }} />
            </div>
          ) : (
            <div
              className="la-kpi-card la-kpi-hero"
              style={{
                padding: 24, borderRadius: 20, background: "#fff",
                border: "1px solid #EAECEF", boxShadow: "0 1px 3px rgba(16,24,40,0.04)",
                height: "100%", display: "flex", flexDirection: "column", gap: 12, gridRow: "span 2",
              }}
            >
              <div className="flex items-center justify-between">
                <span style={{ fontSize: 13, fontWeight: 600, color: "#6B7280", letterSpacing: "0.01em" }}>Total Lead Value</span>
                <span style={{ width: 40, height: 40, borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center", background: `${"#EF4444"}12`, color: "#EF4444" }}>
                  <Icons.FundOutlined style={{ fontSize: 20 }} />
                </span>
              </div>
              <div style={{ fontSize: 34, fontWeight: 800, color: "#111827", lineHeight: 1, letterSpacing: "-0.02em" }}>
                {formatINRFull(totalLeadValue)}
              </div>
              <div className="flex items-center justify-between">
                <span style={{ fontSize: 14, color: "#6B7280", fontWeight: 600 }}>
                  {Number(totalLeads).toLocaleString("en-IN")} leads
                </span>
                <span style={{ fontSize: 13, fontWeight: 700, color: totalLeadsChange >= 0 ? "#22C55E" : "#EF4444", display: "inline-flex", alignItems: "center", gap: 4 }}>
                  {totalLeadsChange >= 0 ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
                  {Math.abs(totalLeadsChange)}
                </span>
              </div>
              <div style={{ flex: 1, minHeight: 40, marginTop: 4 }}>
                <ReactECharts option={sparklineOption(allLeads.map((l: any) => l.createdAt), "#EF4444")} style={{ height: "100%", width: "100%" }} />
              </div>
            </div>
          )}
          {/* Right: 2-row grid of source KPI cards (3 per row on lg, 2 on sm) */}
          <div className="la-kpi-sources" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 20, alignContent: "stretch" }}>
            {loading
              ? Array.from({ length: 6 }).map((_, i) => (
                  <div key={i} style={{ padding: 20, borderRadius: 20, background: "#fff", border: "1px solid #EAECEF", minHeight: 120 }}>
                    <Skeleton active paragraph={{ rows: 2 }} title={{ width: "50%" }} />
                  </div>
                ))
              : [...metrics].sort((a, b) => (b.leadValue || 0) - (a.leadValue || 0)).slice(0, 6).map((metric: any, index: number) => {
                  const accent = metric.color || KPI_ACCENTS[index % KPI_ACCENTS.length];
                  const dates = sparkDataFor(metric.title);
                  return (
                    <div
                      key={metric.title}
                      className="la-kpi-card"
                      style={{
                        padding: 20, borderRadius: 20, background: "#fff",
                        border: "1px solid #EAECEF", boxShadow: "0 1px 3px rgba(16,24,40,0.04)",
                        display: "flex", flexDirection: "column", gap: 8, minHeight: 120,
                      }}
                    >
                      <div className="flex items-center justify-between">
                        <span style={{ fontSize: 13, fontWeight: 600, color: "#6B7280", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 130 }}>{metric.title}</span>
                        <span style={{ width: 34, height: 34, borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", background: `${accent}12`, color: accent, flexShrink: 0 }}>
                          {KPI_ICON[metric.title] || <LineChartOutlined style={{ fontSize: 17 }} />}
                        </span>
                      </div>
                      <div style={{ fontSize: 26, fontWeight: 800, color: "#111827", lineHeight: 1, letterSpacing: "-0.02em" }}>
                        {formatINR(metric.leadValue || 0)}
                      </div>
                      <div className="flex items-center justify-between">
                        <span style={{ fontSize: 12, color: "#6B7280", fontWeight: 600 }}>
                          {metric.filteredLeads} leads
                        </span>
                        <span style={{ fontSize: 11, fontWeight: 700, color: metric.change.style.color || (metric.valueChange >= 0 ? "#22C55E" : "#EF4444"), display: "inline-flex", alignItems: "center", gap: 3 }}>
                          {metric.change.icon}
                          {metric.change.text}
                        </span>
                      </div>
                      <div style={{ height: 24, marginTop: 2 }}>
                        <ReactECharts option={sparklineOption(dates, accent)} style={{ height: "100%", width: "100%" }} />
                      </div>
                    </div>
                  );
                })}
          </div>
        </div>

        {/* ---------- CHART SECTION (60 / 40) ---------- */}
        <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
          {/* Left: Lead Source Analysis (thin progress bars, premium minimal) */}
          <Col xs={24} lg={14}>
            <div className="la-card" style={{ padding: 24, borderRadius: 20, background: "#fff", border: "1px solid #EAECEF", boxShadow: "0 1px 3px rgba(16,24,40,0.04)", height: "100%" }}>
              <div className="flex items-center justify-between" style={{ marginBottom: 24 }}>
                <h3 style={{ fontSize: 18, fontWeight: 700, color: "#111827", margin: 0 }}>Lead Source Analysis</h3>
                <span style={{ fontSize: 12, fontWeight: 600, color: "#6B7280", background: "#F8FAFC", border: "1px solid #E5E7EB", borderRadius: 8, padding: "4px 10px" }}>Real-time</span>
              </div>
              {loading ? (
                <Skeleton active paragraph={{ rows: 6 }} />
              ) : (
                (() => {
                  const sorted = [...metrics].sort((a, b) => (b.leadValue || 0) - (a.leadValue || 0));
                  const totalVal = sorted.reduce((s, m) => s + (m.leadValue || 0), 0);
                  const maxVal = Math.max(...sorted.map((m) => m.leadValue || 0), 1);
                  return (
                    <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
                      {sorted.map((m: any) => {
                        const widthPct = Math.max(((m.leadValue || 0) / maxVal) * 100, (m.leadValue || 0) === 0 ? 1.5 : 2);
                        const fill = m.color || "#94A3B8";
                        return (
                          <div key={m.title} className="flex items-center" style={{ gap: 14 }}>
                            <span style={{ fontSize: 13, fontWeight: 600, color: "#374151", width: 90, flexShrink: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{m.title}</span>
                            <div style={{ flex: 1, height: 8, borderRadius: 999, background: "#EEF2F7", overflow: "hidden" }}>
                              <div className="la-bar-fill" style={{ width: `${widthPct}%`, height: "100%", borderRadius: 999, background: fill, transition: "width 600ms ease" }} />
                            </div>
                            <span style={{ fontSize: 13, fontWeight: 700, color: "#111827", width: 72, flexShrink: 0, textAlign: "right" }}>{formatINR(m.leadValue || 0)}</span>
                          </div>
                        );
                      })}
                      <div style={{ marginTop: 6, paddingTop: 18, borderTop: "1px solid #EEF2F7", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <span style={{ fontSize: 13, fontWeight: 600, color: "#6B7280" }}>Total Lead Value</span>
                        <span style={{ fontSize: 18, fontWeight: 800, color: "#111827" }}>{formatINRFull(totalVal)}</span>
                      </div>
                    </div>
                  );
                })()
              )}
            </div>
          </Col>

          {/* Right: Lead Value Over Time (bar chart, Indian axis) */}
          <Col xs={24} lg={10}>
            <div className="la-card" style={{ padding: 24, borderRadius: 18, background: "#fff", border: "1px solid #EAECEF", boxShadow: "0 1px 3px rgba(16,24,40,0.04)", height: "100%", display: "flex", flexDirection: "column" }}>
              <div className="flex items-center justify-between" style={{ marginBottom: 20 }}>
                <h3 style={{ fontSize: 18, fontWeight: 700, color: "#111827", margin: 0 }}>Lead Value Over Time</h3>
                <Select
                  value={pipelineTimeframe}
                  onChange={(val) => setPipelineTimeframe(val)}
                  style={{ width: 120 }}
                  size="small"
                  options={[
                    { value: "jan-apr", label: "Jan-Apr" },
                    { value: "may-aug", label: "May-Aug" },
                    { value: "sep-dec", label: "Sep-Dec" },
                  ]}
                />
              </div>
              <div style={{ flex: 1, minHeight: 260 }}>
                <ReactECharts option={pipelineChartOptions} style={{ height: "100%", width: "100%" }} />
              </div>
            </div>
          </Col>
        </Row>

        {/* ---------- ANALYTICS SECTION (donuts) ---------- */}
        <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
          <Col xs={24} lg={12}>
            <div className="la-card" style={{ padding: 24, borderRadius: 18, background: "#fff", border: "1px solid #EAECEF", boxShadow: "0 1px 3px rgba(16,24,40,0.04)", height: "100%" }}>
              <div className="flex items-center justify-between" style={{ marginBottom: 20 }}>
                <h3 style={{ fontSize: 18, fontWeight: 700, color: "#111827", margin: 0 }}>Lead Sources</h3>
                <span style={{ fontSize: 12, fontWeight: 600, color: "#6B7280", background: "#F8FAFC", border: "1px solid #E5E7EB", borderRadius: 8, padding: "4px 10px" }}>Distribution</span>
              </div>
              {loading ? (
                <Skeleton active paragraph={{ rows: 5 }} />
              ) : (
                <div className="grid grid-cols-1 sm:grid-cols-12 gap-6 items-center">
                  <div className="sm:col-span-5 flex justify-center items-center">
                    <div style={{ width: 175, height: 175 }}>
                      <ReactECharts option={donutChartOptions} style={{ height: "100%", width: "100%" }} />
                    </div>
                  </div>
                  <div className="sm:col-span-7 flex flex-col gap-1 max-h-[200px] overflow-y-auto pr-1">
                    {donutLegendItems.map((item, idx) => (
                      <div key={idx} className="la-legend-row flex items-center justify-between" style={{ padding: "8px 10px", borderRadius: 10 }}>
                        <div className="flex items-center" style={{ gap: 10, minWidth: 0 }}>
                          <span style={{ width: 9, height: 9, borderRadius: "50%", background: item.color, flexShrink: 0 }} />
                          <span style={{ fontSize: 13, fontWeight: 600, color: "#374151", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{item.name}</span>
                        </div>
                        <div className="flex items-center" style={{ gap: 8 }}>
                          <span style={{ fontSize: 13, fontWeight: 700, color: "#111827" }}>{formatINR(item.leadValue)}</span>
                          <span style={{ fontSize: 11, color: "#9CA3AF", fontWeight: 600 }}>({item.pct}%)</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </Col>
          <Col xs={24} lg={12}>
            <div className="la-card" style={{ padding: 24, borderRadius: 18, background: "#fff", border: "1px solid #EAECEF", boxShadow: "0 1px 3px rgba(16,24,40,0.04)", height: "100%" }}>
              <div className="flex items-center justify-between" style={{ marginBottom: 20 }}>
                <h3 style={{ fontSize: 18, fontWeight: 700, color: "#111827", margin: 0 }}>Lead Status</h3>
                <span style={{ fontSize: 12, fontWeight: 600, color: "#6B7280", background: "#F8FAFC", border: "1px solid #E5E7EB", borderRadius: 8, padding: "4px 10px" }}>Pipeline</span>
              </div>
              {loading ? (
                <Skeleton active paragraph={{ rows: 5 }} />
              ) : (
                <div className="grid grid-cols-1 sm:grid-cols-12 gap-6 items-center">
                  <div className="sm:col-span-5 flex justify-center items-center">
                    <div style={{ width: 175, height: 175 }}>
                      <ReactECharts option={statusDonutChartOptions} style={{ height: "100%", width: "100%" }} />
                    </div>
                  </div>
                  <div className="sm:col-span-7 flex flex-col gap-1 max-h-[200px] overflow-y-auto pr-1">
                    {statusLegendItems.map((item, idx) => (
                      <div key={idx} className="la-legend-row flex items-center justify-between" style={{ padding: "8px 10px", borderRadius: 10 }}>
                        <div className="flex items-center" style={{ gap: 10, minWidth: 0 }}>
                          <span style={{ width: 9, height: 9, borderRadius: "50%", background: item.color, flexShrink: 0 }} />
                          <span style={{ fontSize: 13, fontWeight: 600, color: "#374151", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{item.name}</span>
                        </div>
                        <div className="flex items-center" style={{ gap: 8 }}>
                          <span style={{ fontSize: 13, fontWeight: 700, color: "#111827" }}>{item.leadCount.toLocaleString("en-IN")}</span>
                          <span style={{ fontSize: 11, color: "#9CA3AF", fontWeight: 600 }}>({item.pct}%)</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </Col>
        </Row>

        {/* ---------- RECENT LEADS TABLE ---------- */}
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <div className="la-card" style={{ padding: 24, borderRadius: 18, background: "#fff", border: "1px solid #EAECEF", boxShadow: "0 1px 3px rgba(16,24,40,0.04)" }}>
              <div className="flex items-center justify-between" style={{ marginBottom: 20 }}>
                <h3 style={{ fontSize: 18, fontWeight: 700, color: "#111827", margin: 0 }}>Recent Leads</h3>
              </div>
              {loading ? (
                <Skeleton active paragraph={{ rows: 6 }} />
              ) : (
                <div className="la-table-wrap" style={{ borderRadius: 12, overflow: "hidden", border: "1px solid #EAECEF" }}>
                  <style>{`
                    .la-table-wrap .ant-table-thead > tr > th {
                      background: #F8FAFC !important;
                      color: #6B7280 !important;
                      font-size: 11px !important;
                      text-transform: uppercase !important;
                      letter-spacing: 0.05em !important;
                      font-weight: 700 !important;
                      border-bottom: 1px solid #EAECEF !important;
                      padding: 12px 14px !important;
                    }
                    .la-table-wrap .ant-table-tbody > tr > td {
                      border-bottom: 1px solid #F1F5F9 !important;
                      padding: 12px 14px !important;
                    }
                    .la-table-wrap .ant-table-tbody > tr:hover > td {
                      background: #F8FAFC !important;
                    }
                    .la-table-wrap .ant-table { background: transparent !important; }
                    .la-card { transition: box-shadow 200ms ease, transform 200ms ease; }
                    .la-card:hover { box-shadow: 0 8px 24px rgba(16,24,40,0.08) !important; transform: translateY(-2px); }
                    .la-kpi-card { transition: box-shadow 200ms ease, transform 200ms ease; }
                    .la-kpi-card:hover { box-shadow: 0 8px 24px rgba(16,24,40,0.08) !important; transform: translateY(-2px); }
                    .la-legend-row:hover { background: #F8FAFC; }
                    .la-bar-fill { transition: width 600ms ease; }
                    .la-fav-name:hover { border-color: #1e3a8a !important; }
                    .la-fav-name:focus, .la-fav-name.ant-input:focus, .la-fav-name.ant-input-focused { border-color: #1e3a8a !important; box-shadow: 0 0 0 3px rgba(30,58,138,0.12) !important; outline: none !important; }
                    .la-fav-name::placeholder { color: #9CA3AF !important; font-weight: 400 !important; }
                    .la-inline-filter > div:last-child > div { max-width: 100% !important; height: auto !important; max-height: 60vh !important; box-shadow: none !important; background: #fff !important; }
                    @media (max-width: 1024px) {
                      .la-kpi-sources { gridTemplateColumns: repeat(2, 1fr) !important; }
                    }
                    @media (max-width: 768px) {
                      .la-kpi-grid { gridTemplateColumns: 1fr !important; }
                      .la-kpi-hero { gridRow: span 1 !important; }
                      .la-kpi-sources { gridTemplateColumns: 1fr !important; }
                    }
                  `}</style>
                  <Table
                    dataSource={topDeals}
                    columns={[
                      { title: "Lead ID", dataIndex: "leadCode", key: "leadCode", width: 100,
                        render: (t: string) => <span style={{ fontFamily: "monospace", fontSize: 12, color: "#9CA3AF" }}>{t || "—"}</span> },
                      { title: "Project", dataIndex: "title", key: "title", ellipsis: true,
                        render: (t: string) => <span style={{ fontSize: 13, fontWeight: 700, color: "#111827" }}>{t || "—"}</span> },
                      { title: "Client", dataIndex: "contactName", key: "contactName", ellipsis: true,
                        render: (t: string) => <span style={{ fontSize: 13, fontWeight: 600, color: "#374151" }}>{t || "—"}</span> },
                      { title: "Company", dataIndex: "company", key: "company", ellipsis: true,
                        render: (t: string) => <span style={{ fontSize: 13, fontWeight: 500, color: "#6B7280" }}>{t || "—"}</span> },
                      { title: "Lead Value", dataIndex: "leadValue", key: "leadValue", ellipsis: true,
                        render: (t: any) => <span style={{ fontSize: 13, fontWeight: 700, color: "#111827" }}>{formatINR(Number(t) || 0)}</span> },
                      { title: "Created Date", dataIndex: "createdAt", key: "createdAt", width: 140,
                        render: (t: string) => <span style={{ fontSize: 12, color: "#6B7280" }}>{t ? dayjs(t).format("DD MMM YYYY") : "—"}</span> },
                      { title: "Status", dataIndex: "leadstatus", key: "leadstatus", width: 160,
                        render: (status: any, record: any) => {
                          const ls = record.leadstatus || record.status;
                          if (!ls) return <span style={{ fontSize: 12, color: "#9CA3AF" }}>—</span>;
                          let name = "Unknown", color = "#94A3B8";
                          if (typeof ls === "string") {
                            const f = statuses.find((s: any) => s._id === ls || s.slug === ls || s.name === ls);
                            if (f) { name = f.name; color = f.color; } else { name = ls; }
                          } else if (typeof ls === "object") {
                            const f = statuses.find((s: any) => s._id === ls._id || s.slug === ls.slug || s.name === ls.name);
                            if (f) { name = f.name; color = f.color; } else { name = ls.name || "Unknown"; color = ls.color || "#94A3B8"; }
                          }
                          return (
                            <span style={{ background: `${color}14`, color, border: `1px solid ${color}33`, borderRadius: 8, padding: "4px 10px", fontSize: 11, fontWeight: 700, whiteSpace: "nowrap", display: "inline-block" }}>
                              {name}
                            </span>
                          );
                        },
                      },
                    ]}
                    pagination={false}
                    size="middle"
                    rowKey={(r) => r._id || r.leadCode}
                  />
                </div>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </div>
    </Spin>
  );
};

export default LeadsAnalytics;
